import React, { useContext, useEffect, useRef, lazy, Suspense, useState, use } from "react";
import { Button } from "../ui/button"
import { Input } from "../ui/input"
import { Label } from "../ui/label"
import { Textarea } from "../ui/textarea"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select"
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { Type, ImageIcon, Sparkles, Move, RotateCcw, Camera, Video, MapPin, } from "lucide-react"
import { message, useCRUDController, Checkbox, Form, Divider, Row, Col, transformFormColumnDataToFiveWData, transformFiveWDataToFormColumnData, LucideIcon, TempDataProvider } from "./ot"
import BaseCanvasEdit_3_1_Form from "./base_canvas_edit_3_1_form"
import BaseCanvasEdit_3_1_SettingToolForm from "./base_canvas_edit_3_1_setting_tool_form"
import Base5wCard from "./base_5w_card";
import { get5wFormColumns } from "./base_canvas_element_utils";
const BaseCanvasEdit3_1 = ({
    showTabkey = ["setting_tool","properties", "ai","step_setting"],
    elementsData = [],
    elementData = [],
    selectedComponentId = null,
    componentAttributesData = [],
    componentCommonAttributesData = [],
    canvasElement = [],
    onChangeComponentEffect = () => { },
    onFinishAIResult = () => { },
    aiGenerateAPIRoute = "/utility/ai_produce",
    onChangecanvasElement = () => { },
    documentFiveWAPI = '/utility/document/base_view',
    fiveWResponseAPI = "/utility/response/cache",
    five_w_id,
    documentController,
    dropDownDocumentController,
    dropDownDocumentAPiRoute,
    selectElementId,
    fiveWResponseData = [],
    allDocumentData = [],
}) => {
    const [form] = Form.useForm();
    const [form_setting_tool] = Form.useForm();
    const [axiosMode, setAxiosMode] = useState("post");
    const [aiReturnData, setAiReturnData] = useState(null)
    const [elementFiveWFormFormColumnData, setElementFiveWFormFormColumnData] = useState([]);

    const onFormFinish = (values) => {
        let finalData = { ...values, input: canvasElement }
        finalData = {
            'target': elementData?.component_definitions_classify_structure_type_data?.find(_ => true)?.name_language_data?.find(_ => true)?.language_culture_value,
            ...finalData,
        }
        if (axiosMode === "post") {
            AiProduceController.postData([finalData]);
        } else if (axiosMode === "patch") {
            AiProduceController.patchData([finalData]);
        }
    };

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === 'get') {
            } else if (axiosMode === "post") {
                setAiReturnData(values)
            } else if (axiosMode === "patch") {
            } else if (axiosMode === "delete") {
            }
        } else if (status === "error") {
            // if (axiosMode === "post") {
            //     actionRef.current.reloadAndRest();
            // } else if (axiosMode === "patch") {
            //     actionRef.current.reloadAndRest();
            // } else if (axiosMode === "delete") {
            //     actionRef.current.reloadAndRest();
            // }
        }
    };

    const applyAIResult = () => {
        onFinishAIResult(aiReturnData)
        // console.log({"result": aiReturnData, "canvasElement": canvasElement})
    }

    const datetimeFormat = (value, content) => {
        const dateObj = content === "" ? new Date() : new Date(content);
        if (isNaN(dateObj.getTime())) return onChangeComponentEffect("", "content");
        const pad = (num) => String(num).padStart(2, '0');
        const yyyy = dateObj.getFullYear();
        const mm = pad(dateObj.getMonth() + 1);
        const dd = pad(dateObj.getDate());
        const hh = pad(dateObj.getHours());
        const mi = pad(dateObj.getMinutes());
        const ss = pad(dateObj.getSeconds());
        switch (value) {
            case 'date-only':
                return onChangeComponentEffect(`${yyyy}-${mm}-${dd}`, 'content');
            case 'time-only':
                return onChangeComponentEffect(`${hh}:${mi}:${ss}`, 'content');
            case 'relative':
                const now = new Date();
                const diffMs = dateObj.getTime() - now.getTime();
                const diffSec = Math.round(diffMs / 1000);
                const diffMin = Math.round(diffSec / 60);
                const diffHour = Math.round(diffMin / 60);
                const diffDay = Math.round(diffHour / 24);

                if (Math.abs(diffSec) < 60) {
                    return onChangeComponentEffect('剛剛', "content");
                } else if (Math.abs(diffMin) < 60) {
                    return onChangeComponentEffect(diffMin > 0 ? `${diffMin}分鐘後` : `${Math.abs(diffMin)}分鐘前`, "content");
                } else if (Math.abs(diffHour) < 24) {
                    return onChangeComponentEffect(diffHour > 0 ? `${diffHour}小時後` : `${Math.abs(diffHour)}小時前`, "content");
                } else {
                    return onChangeComponentEffect(diffDay > 0 ? `${diffDay}天後` : `${Math.abs(diffDay)}天前`, "content");
                }
            default:
                return onChangeComponentEffect(`${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`, 'content');
        }
    }
    const handleComponentEffect = (value, component, groupName) => {
        const attributeCSS = component?.propety_json?.attribute_css
        if (!!groupName) {
            if (!!attributeCSS) {
                onChangeComponentEffect({ [attributeCSS]: value }, groupName)
            }
        }
        else {
            if (!!attributeCSS) {
                onChangeComponentEffect(value, attributeCSS)
            }
        }

        // switch (attributeCSS) {
        //     case "arrowType":
        //         return onChangeComponentEffect({ arrowType: value }, "style")
        //     case "lineStyle":
        //         return onChangeComponentEffect({ lineStyle: value }, "style")
        //     case "fontSize":
        //         return onChangeComponentEffect({ fontSize: value }, "style")
        //     case "fontWeight":
        //         return onChangeComponentEffect({ fontWeight: value }, "style")
        //     case "fontFamily":
        //         return onChangeComponentEffect({ fontFamily: value }, "style")
        //     case "lineHeight":
        //         return onChangeComponentEffect({ lineHeight: value }, "style")
        //     case "letterSpacing":
        //         return onChangeComponentEffect({ letterSpacing: value }, "style")
        //     case "alignItems":
        //         return onChangeComponentEffect({ alignItems: value }, "style")
        //     case "boxShadow":
        //         return onChangeComponentEffect({ boxShadow: value }, "style")
        //     case "borderRadius":
        //         return onChangeComponentEffect({ borderRadius: value }, "style")
        //     case "backgroundColor":
        //         return onChangeComponentEffect({ backgroundColor: value }, "style")
        //     case "foregroundColor":
        //         return onChangeComponentEffect({ foregroundColor: value }, "style")
        //     case "padding":
        //         return onChangeComponentEffect({ padding: value + "px" }, "style")
        //     case "margin":
        //         return onChangeComponentEffect({ margin: value + "px" }, "style")
        //     case "width":
        //         return onChangeComponentEffect({ width: value }, "style")
        //     case "paragraphType":
        //         if (value === "split") {
        //             const paragraph = canvasElement?.content.split("\n\n").map((para, i) => (
        //                 <p key={i} style={canvasElement?.style}>{para}</p>
        //             ))
        //             return onChangeComponentEffect(paragraph, "content")
        //         }
        //         else if (value === "ordered-list") {
        //             const paragraph = <ol style={canvasElement?.style}>
        //                 {canvasElement?.content.split("\n").map((line, i) => (
        //                     <li key={i}>{line}</li>
        //                 ))}
        //             </ol>
        //             return onChangeComponentEffect(paragraph, "content")
        //         }
        //         else if (value === "bullet-list") {
        //             const paragraph = <ul style={canvasElement?.style}>
        //                 {canvasElement?.content.split("\n").map((line, i) => (
        //                     <li key={i}>{line}</li>
        //                 ))}
        //             </ul>
        //             return onChangeComponentEffect(paragraph, "content")
        //         }
        //         return onChangeComponentEffect(<p style={canvasElement?.style}>{canvasElement?.content}</p>, "content")
        //     case "backgroundType":
        //         return onChangeComponentEffect({ backgroundType: value }, "style")
        //     case "hasBorder":
        //         return onChangeComponentEffect({ hasBorder: value }, "style")
        //     case "borderRadiusType":
        //         return onChangeComponentEffect({ borderRadiusType: value }, "style")
        //     case "textAlign":
        //         return onChangeComponentEffect({ textAlign: value }, "style")
        //     case "aspectRatio":
        //         return onChangeComponentEffect({ aspectRatio: value }, "style")
        //     case "coverStyle":
        //         return onChangeComponentEffect({ coverStyle: value }, "style")
        //     case "displayMode":
        //         return onChangeComponentEffect({ displayMode: value }, "style")
        //     case "tagStyle":
        //         return onChangeComponentEffect({ tagStyle: value }, "style")
        //     case "separatorType":
        //         return onChangeComponentEffect({ separatorType: value }, "style")
        //     case "buttonText":
        //         return onChangeComponentEffect(value, "content")
        //     case "buttonVariant":
        //         return onChangeComponentEffect({ buttonVariant: value }, "style")
        //     case "datetime_format":
        //         return datetimeFormat(value, canvasElement?.content)
        //     case "timezone":
        //         const timezoneObj = canvasElement?.content === "" ? new Date() : new Date(canvasElement?.content);
        //         if (isNaN(timezoneObj.getTime())) return onChangeComponentEffect("", "content");
        //         // Intl 轉時區
        //         const formatter = new Intl.DateTimeFormat('en-US', {
        //             timeZone: value,
        //             year: 'numeric',
        //             month: '2-digit',
        //             day: '2-digit',
        //             hour: '2-digit',
        //             minute: '2-digit',
        //             second: '2-digit'
        //         });
        //         const formatted = new Date(formatter.format(timezoneObj));
        //         // Step 2: 自己組字串
        //         const pad = (n) => String(n).padStart(2, '0');
        //         const targetDate = `${formatted.getFullYear()}-${pad(formatted.getMonth() + 1)}-${pad(formatted.getDate())} ${pad(formatted.getHours())}:${pad(formatted.getMinutes())}:${pad(formatted.getSeconds())}`;
        //         return datetimeFormat("", targetDate)
        //     case "qrcode-size":
        //         return onChangeComponentEffect({ size: value, style: { width: value, height: value } }, "qrcode")
        //     case "qrcode-border":
        //         switch (value) {
        //             case "simple":
        //                 return onChangeComponentEffect({ style: { border: "1px solid #ccc", borderRadius: "0px", boxShadow: "" } }, "qrcode")
        //             case "rounded":
        //                 return onChangeComponentEffect({ style: { border: "1px solid #ccc", borderRadius: "12px", boxShadow: "" } }, "qrcode")
        //             case "shadow":
        //                 return onChangeComponentEffect({ style: { border: "", borderRadius: "", boxShadow: "0 2px 8px rgba(0,0,0,0.2)" } }, "qrcode")
        //             default:
        //                 return onChangeComponentEffect({ style: { border: "", borderRadius: "", boxShadow: "" } }, "qrcode")
        //         }
        //     case "location":
        //         return onChangeComponentEffect({ location_type: value }, "location")
        //     default:
        //         return onChangeComponentEffect(value, attributeCSS)
        // }
    }

    const getComponentProperties = (componentData) => {
        if (!componentData) {
            return <></>
        }

        const commonProperties = (<>
            {componentCommonAttributesData.map((component, index) => {
                if (component?.is_ai !== 0) {
                    return <></>
                }
                if (component?.is_default === 0) {
                    return <></>
                }
                switch (component?.component_type) {
                    case "SELECT":
                        return (
                            <div key={index}>
                                <Label className="text-sm font-medium">
                                    {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                </Label>
                                <Select onValueChange={(value) => { handleComponentEffect(value, component) }}>
                                    <SelectTrigger className="mt-1">
                                        <SelectValue placeholder={component?.propety_json?.placeholder ?? ""} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {component?.propety_option_json?.data?.map((option) => (
                                            <SelectItem key={option?.value} value={option?.value}>
                                                {option?.label}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </div>
                        );
                    case "CHECKBOX":
                        return (
                            <div key={index}>
                                <Label className="text-sm font-medium">
                                    {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                </Label>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="image-border"
                                        checked={!!canvasElement?.style?.hasBorder}
                                        onCheckedChange={(value) => {
                                            handleComponentEffect(value, component)
                                        }}
                                    />
                                    <Label htmlFor="image-border" className="text-sm">
                                        {component?.propety_json?.placeholder ?? ""}
                                    </Label>
                                </div>
                            </div>
                        );
                    case "CHECKBOX_SWITCH":
                        return (
                            <div className="flex items-center justify-between p-3 rounded-md border">
                                <Label className="text-sm cursor-pointer">
                                    全寬按鈕
                                </Label>
                                <Checkbox
                                    checked={!!canvasElement?.style?.hasBorder}
                                    onCheckedChange={(value) => {
                                        handleComponentEffect(value, component)
                                    }}
                                />
                            </div>
                        )
                    case "INPUT":
                        return (
                            <div key={index}>
                                <Label className="text-sm font-medium">
                                    {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                </Label>
                                <Input
                                    type="text"
                                    placeholder={component?.propety_json?.placeholder ?? ""}
                                    className="mt-1"
                                    value={canvasElement?.content}
                                    onChange={(e) => {
                                        handleComponentEffect(e.target.value, component)
                                    }}
                                />
                            </div>
                        );
                    case "COLOR_PICKER":
                        return (
                            <div key={index}>
                                <div>
                                    <Label className="text-sm font-medium">
                                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                    </Label>
                                    <div className="flex gap-2 mt-1">
                                        {component?.propety_option_json?.data?.map((option) => (
                                            <div
                                                className="w-8 h-8 rounded border cursor-pointer"
                                                style={{ backgroundColor: option?.value }}
                                                onClick={() => { handleComponentEffect(option?.value, component) }}
                                            ></div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        );
                    case "COLOR_PICKER2":
                        return (
                            <div key={index}>
                                <div>
                                    <Label className="text-sm font-medium">
                                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                    </Label>
                                    <div className="flex gap-2 mt-1">
                                        {component?.propety_option_json?.data?.map((option) => (
                                            <div
                                                className="w-8 h-8 rounded border cursor-pointer"
                                                style={{ backgroundColor: option?.value }}
                                                onClick={() => { handleComponentEffect(option?.value, component) }}
                                            ></div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        );
                    case "INPUT_NUMBER":
                        return (
                            <div key={index}>
                                <Label className="text-sm font-medium">
                                    {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                </Label>
                                <Input
                                    type="number"
                                    placeholder={component?.propety_json?.placeholder ?? ""}
                                    className="mt-1"
                                    value={canvasElement?.style?.[component?.propety_json?.attribute_css]?.replace("px", "")}
                                    onChange={(e) => {
                                        handleComponentEffect(e.target.value, component)
                                    }}
                                />
                            </div>

                        );
                    case "BUTTON_GROUP":
                        return (
                            <div key={index}>
                                <Label className="text-sm font-medium">
                                    {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                </Label>
                                <div className="mt-2 flex space-x-2">
                                    {component?.propety_option_json?.data?.map((option) => {
                                        return (
                                            <Button

                                                key={option?.value}
                                                variant={canvasElement?.style?.[component?.propety_json?.attribute_css] === option?.value ? "default" : "outline"}
                                                onClick={() => { handleComponentEffect(option?.value, component) }}
                                            >
                                                <LucideIcon name={option?.icon} className="w-4 h-4" /> {option?.label}
                                            </Button>
                                        )
                                    })}
                                </div>
                            </div>
                        );
                    default:
                        return <></>;
                }
            })}
        </>)
        const specificProperties = (
            <>
                {componentData.map((component, index) => {
                    if (component?.is_ai !== 0) {
                        return <></>
                    }
                    if (component?.is_default !== 0) {
                        return <></>
                    }
                    switch (component?.component_type) {
                        case "SELECT":
                            return (
                                <div key={index}>
                                    <Label className="text-sm font-medium">
                                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                    </Label>
                                    <Select onValueChange={(value) => {
                                        handleComponentEffect(value, component)
                                    }}>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder={component?.propety_json?.placeholder ?? ""} />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {component?.propety_option_json?.data?.map((option) => (
                                                <SelectItem key={option?.value} value={option?.value}>
                                                    {option?.label}
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>
                            );
                        case "CHECKBOX":
                            return (
                                <div key={index}>
                                    <Label className="text-sm font-medium">
                                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                    </Label>
                                    <div className="flex items-center space-x-2">
                                        <Checkbox id="image-border" />
                                        <Label htmlFor="image-border" className="text-sm">
                                            {component?.propety_json?.placeholder ?? ""}
                                        </Label>
                                    </div>
                                </div>
                            );
                        case "INPUT":
                            return (
                                <div key={index}>
                                    <Label className="text-sm font-medium">
                                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                    </Label>
                                    <Input
                                        type="text"
                                        placeholder={component?.propety_json?.placeholder ?? ""}
                                        className="mt-1"
                                        value={canvasElement?.content}
                                    />
                                </div>
                            );
                        case "COLOR_PICKER":
                            return (
                                <div key={index}>
                                    <div>
                                        <Label className="text-sm font-medium">
                                            {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                                        </Label>
                                        <div className="flex gap-2 mt-1">
                                            {component?.propety_option_json?.data?.map((option) => (
                                                <div
                                                    className="w-8 h-8 rounded border cursor-pointer"
                                                    style={{ backgroundColor: option?.value }}
                                                    onClick={() => { handleComponentEffect(option?.value, component) }}
                                                ></div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            );

                        default:
                            return <></>;
                    }
                })}
            </>
        );
        return (
            <div className="space-y-6">
                <div className="space-y-4">
                    <h4 className="font-medium text-gray-900 border-b pb-2">{elementData?.component_definitions_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value}元件屬性</h4>
                    {specificProperties}
                </div>
                <div className="space-y-4">
                    <h4 className="font-medium text-gray-900 border-b pb-2">通用樣式屬性</h4>
                    {commonProperties}
                </div>
            </div>
        )
    }

    const getAIToolsForComponent = (componentType) => {
        switch (componentType) {
            case "title":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            標題 AI 工具
                            <Button className="bg-blue-500 hover:bg-blue-600" onClick={applyAIResult}>
                                <Sparkles className="w-4 h-4 mr-2" />
                                套用
                            </Button>
                        </h4>
                        {/* AI 自動產生標題 */}
                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Button className="w-full bg-green-500 hover:bg-green-600"
                                    onClick={() => {
                                        onFormFinish(form.getFieldsValue())
                                    }}>
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    生成
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <div
                                        className="text-sm"
                                        dangerouslySetInnerHTML={{ __html: aiReturnData?.output || '' }}
                                    />
                                    <span className="text-xs text-gray-500">{aiReturnData?.user_select_text}</span>
                                </div>
                            </div>
                        </div>

                        <BaseCanvasEdit_3_1_Form
                            propsForm={form}
                            // field
                            formReloadCount={0}
                            // propsOnValuesChange= () => { }
                            // defaultValue={}
                            onFormFinish={onFormFinish}
                            componentAttributesData={componentAttributesData.filter(item => item.is_ai === 1) || []}
                        />
                    </div>
                )

            case "text-content":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            文字內容 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600" onClick={applyAIResult}>
                                <Sparkles className="w-4 h-4 mr-2" />
                                套用到文字內容
                            </Button>
                        </h4>

                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Button className="w-full bg-green-500 hover:bg-green-600"
                                    onClick={() => {
                                        onFormFinish(form.getFieldsValue())
                                    }}>
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    生成
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <div
                                        className="text-sm"
                                        dangerouslySetInnerHTML={{ __html: aiReturnData?.output || '' }}
                                    />
                                    <span className="text-xs text-gray-500">{aiReturnData?.user_select_text}</span>
                                </div>
                            </div>
                        </div>
                        <BaseCanvasEdit_3_1_Form
                            propsForm={form}
                            // field
                            formReloadCount={0}
                            // propsOnValuesChange= () => { }
                            // defaultValue={}
                            onFormFinish={onFormFinish}
                            componentAttributesData={componentAttributesData.filter(item => item.is_ai === 1) || []}
                        />
                    </div>
                )

            case "image":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            圖片 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                生成拼圖設計
                            </Button>
                        </h4>

                        {/* 上傳圖片 */}
                        {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">上傳圖片（最多8張）</Label>
                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 cursor-pointer">
                                <ImageIcon className="w-8 h-8 mx-auto mb-2 text-gray-400" />
                                <p className="text-sm text-gray-600">點擊上傳或拖拉圖片</p>
                                <p className="text-xs text-gray-500">支援 JPG/PNG，建議比例 1:1 或 3:4</p>
                            </div>
                            <div className="grid grid-cols-4 gap-2">
                                {Array.from({ length: 4 }, (_, i) => (
                                    <div
                                        key={i}
                                        className="aspect-square bg-gray-100 rounded border-2 border-dashed border-gray-300 flex items-center justify-center"
                                    >
                                        <span className="text-xs text-gray-400">圖片 {i + 1}</span>
                                    </div>
                                ))}
                            </div>
                        </div> */}

                        {/* 背景移除 */}
                        {/* <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Label className="text-sm font-medium">背景移除（選配）</Label>
                                <Button size="sm" variant="outline">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    AI去背
                                </Button>
                            </div>
                            <p className="text-xs text-gray-500">AI 自動移除背景，讓主體更突出</p>
                        </div> */}

                        <div className="space-y-3">
                            <Label className="text-sm font-medium">視覺目標選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">視覺目標</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇視覺目標..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="attract">吸引注意</SelectItem>
                                            <SelectItem value="explain">說明功能</SelectItem>
                                            <SelectItem value="atmosphere">建立氛圍</SelectItem>
                                            <SelectItem value="brand">強化品牌</SelectItem>
                                            <SelectItem value="context">補充情境</SelectItem>
                                            <SelectItem value="instruction">顯示使用方法</SelectItem>
                                            <SelectItem value="highlight-copy">襯托文案</SelectItem>
                                            <SelectItem value="guide-eye">引導視線</SelectItem>
                                            <SelectItem value="trust">營造信任感</SelectItem>
                                            <SelectItem value="resonance">引發共鳴</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">情緒氛圍選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">情緒氛圍</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇氛圍..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="relaxed">輕鬆</SelectItem>
                                            <SelectItem value="warm">溫暖</SelectItem>
                                            <SelectItem value="professional">專業</SelectItem>
                                            <SelectItem value="innovative">創新</SelectItem>
                                            <SelectItem value="safe">安全</SelectItem>
                                            <SelectItem value="passionate">熱血</SelectItem>
                                            <SelectItem value="concise">簡潔</SelectItem>
                                            <SelectItem value="natural">自然</SelectItem>
                                            <SelectItem value="joyful">歡樂</SelectItem>
                                            <SelectItem value="touching">感動</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">搭配語境選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">搭配語境</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇搭配語境..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="headline">標題強化</SelectItem>
                                            <SelectItem value="paragraph">段落插圖</SelectItem>
                                            <SelectItem value="card">卡片配圖</SelectItem>
                                            <SelectItem value="endnote">文末點綴</SelectItem>
                                            <SelectItem value="steps">步驟引導</SelectItem>
                                            <SelectItem value="faq">FAQ 圖示</SelectItem>
                                            <SelectItem value="section-color">章節配色</SelectItem>
                                            <SelectItem value="cta-bg">CTA 背景</SelectItem>
                                            <SelectItem value="hero">Hero 主圖</SelectItem>
                                            <SelectItem value="form">表單圖例</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">主體風格選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">主體風格</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇主體風格..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="minimal">極簡線條</SelectItem>
                                            <SelectItem value="photo">實物寫真</SelectItem>
                                            <SelectItem value="illustration">插畫角色</SelectItem>
                                            <SelectItem value="flowchart">流程圖</SelectItem>
                                            <SelectItem value="geometry">幾何圖形</SelectItem>
                                            <SelectItem value="perspective">透視構圖</SelectItem>
                                            <SelectItem value="texture">背景紋理</SelectItem>
                                            <SelectItem value="solid">純色塊</SelectItem>
                                            <SelectItem value="silhouette">剪影</SelectItem>
                                            <SelectItem value="composite">合成風</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">關聯程度選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">關聯程度</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇關聯方式..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="symbolic">象徵代表</SelectItem>
                                            <SelectItem value="extended">延伸補充</SelectItem>
                                            <SelectItem value="associative">引發聯想</SelectItem>
                                            <SelectItem value="product">產品示意</SelectItem>
                                            <SelectItem value="usage">使用畫面</SelectItem>
                                            <SelectItem value="brand">品牌視覺</SelectItem>
                                            <SelectItem value="scene">使用場景</SelectItem>
                                            <SelectItem value="value">價值強調</SelectItem>
                                            <SelectItem value="background">氛圍背景</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>

                        {/* 自動拼圖排版 */}
                        {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">自動拼圖排版</Label>
                            <div className="grid grid-cols-3 gap-2">
                                <div className="border rounded p-2 cursor-pointer hover:bg-blue-50">
                                    <div className="grid grid-cols-2 gap-1 mb-1">
                                        {Array.from({ length: 4 }, (_, i) => (
                                            <div key={i} className="aspect-square bg-gray-200 rounded-sm"></div>
                                        ))}
                                    </div>
                                    <span className="text-xs">2×2</span>
                                </div>
                                <div className="border rounded p-2 cursor-pointer hover:bg-blue-50">
                                    <div className="grid grid-cols-3 gap-1 mb-1">
                                        {Array.from({ length: 6 }, (_, i) => (
                                            <div key={i} className="aspect-square bg-gray-200 rounded-sm"></div>
                                        ))}
                                    </div>
                                    <span className="text-xs">3×2</span>
                                </div>
                                <div className="border rounded p-2 cursor-pointer hover:bg-blue-50">
                                    <div className="grid grid-cols-3 gap-1 mb-1">
                                        {Array.from({ length: 9 }, (_, i) => (
                                            <div key={i} className="aspect-square bg-gray-200 rounded-sm"></div>
                                        ))}
                                    </div>
                                    <span className="text-xs">3×3</span>
                                </div>
                            </div>
                        </div> */}

                    </div>
                )

            case "photo":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            照片 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                套用照片設定
                            </Button>
                        </h4>

                        {/* 上傳照片 */}
                        {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">上傳實拍照片</Label>
                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 cursor-pointer">
                                <Camera className="w-8 h-8 mx-auto mb-2 text-gray-400" />
                                <p className="text-sm text-gray-600">點擊上傳或拖拉照片</p>
                                <p className="text-xs text-gray-500">支援 JPG/PNG/HEIC，高解析度照片</p>
                            </div>
                        </div> */}

                        {/* AI 照片優化 */}
                        {/* <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Label className="text-sm font-medium">AI 照片優化</Label>
                                <Button size="sm" className="bg-blue-500 hover:bg-blue-600">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    一鍵優化
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="auto-enhance" />
                                    <Label htmlFor="auto-enhance" className="text-sm">
                                        自動增強亮度對比
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="color-correction" />
                                    <Label htmlFor="color-correction" className="text-sm">
                                        色彩校正
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="noise-reduction" />
                                    <Label htmlFor="noise-reduction" className="text-sm">
                                        降噪處理
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="sharpen" />
                                    <Label htmlFor="sharpen" className="text-sm">
                                        銳化處理
                                    </Label>
                                </div>
                            </div>
                        </div> */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">語意屬性選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">語意屬性</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇語意屬性..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="promotion">促銷</SelectItem>
                                            <SelectItem value="brand">品牌</SelectItem>
                                            <SelectItem value="event">活動</SelectItem>
                                            <SelectItem value="emotion">情緒</SelectItem>
                                            <SelectItem value="trend">趨勢</SelectItem>
                                            <SelectItem value="knowledge">知識</SelectItem>
                                            <SelectItem value="industry">產業</SelectItem>
                                            <SelectItem value="lifestyle">生活</SelectItem>
                                            <SelectItem value="region">地區</SelectItem>
                                            <SelectItem value="identity">身分</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">文字組合選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">文字組合</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇文字組合風格..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="word">單字</SelectItem>
                                            <SelectItem value="phrase">詞組</SelectItem>
                                            <SelectItem value="camelCase">駝峰式</SelectItem>
                                            <SelectItem value="emoji">帶 Emoji</SelectItem>
                                            <SelectItem value="verbFirst">動詞開頭</SelectItem>
                                            <SelectItem value="nounFirst">名詞主體</SelectItem>
                                            <SelectItem value="adjective">形容詞描述</SelectItem>
                                            <SelectItem value="english">英文為主</SelectItem>
                                            <SelectItem value="mix">中英混搭</SelectItem>
                                            <SelectItem value="placeSuffix">地名尾綴</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>

                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">策略目的選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">策略目的</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇使用策略..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="tagging">分類標記</SelectItem>
                                            <SelectItem value="push">推播追蹤</SelectItem>
                                            <SelectItem value="branding">品牌曝光</SelectItem>
                                            <SelectItem value="seo">搜尋優化</SelectItem>
                                            <SelectItem value="crossplatform">跨平台統一</SelectItem>
                                            <SelectItem value="buzz">話題引流</SelectItem>
                                            <SelectItem value="eventid">活動識別</SelectItem>
                                            <SelectItem value="ugc">用戶生成</SelectItem>
                                            <SelectItem value="social">社群互動</SelectItem>
                                            <SelectItem value="coCreation">用戶共創</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">建議使用數量選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">建議使用數量</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="建議選用幾個？" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {[...Array(10)].map((_, i) => (
                                                <SelectItem key={i + 1} value={`${i + 1}`}>{i + 1}個</SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">排序方式選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">排序方式</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇排序邏輯..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="theme">主題先</SelectItem>
                                            <SelectItem value="brand">品牌先</SelectItem>
                                            <SelectItem value="location">地點先</SelectItem>
                                            <SelectItem value="emotion">情感先</SelectItem>
                                            <SelectItem value="action">行動先</SelectItem>
                                            <SelectItem value="hot">熱門前</SelectItem>
                                            <SelectItem value="featured">精選前</SelectItem>
                                            <SelectItem value="interlace">長短交錯</SelectItem>
                                            <SelectItem value="semanticGroup">語意分組</SelectItem>
                                            <SelectItem value="frequency">頻率排序</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">語意屬性選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">語意屬性</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇語意屬性..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="promotion">促銷</SelectItem>
                                            <SelectItem value="brand">品牌</SelectItem>
                                            <SelectItem value="event">活動</SelectItem>
                                            <SelectItem value="emotion">情緒</SelectItem>
                                            <SelectItem value="trend">趨勢</SelectItem>
                                            <SelectItem value="knowledge">知識</SelectItem>
                                            <SelectItem value="industry">產業</SelectItem>
                                            <SelectItem value="lifestyle">生活</SelectItem>
                                            <SelectItem value="region">地區</SelectItem>
                                            <SelectItem value="identity">身分</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">語意屬性選擇</Label>
                            <div className="space-y-2">
                                <div>
                                    <Label className="text-xs text-gray-600">語意屬性</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇語意屬性..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="promotion">促銷</SelectItem>
                                            <SelectItem value="brand">品牌</SelectItem>
                                            <SelectItem value="event">活動</SelectItem>
                                            <SelectItem value="emotion">情緒</SelectItem>
                                            <SelectItem value="trend">趨勢</SelectItem>
                                            <SelectItem value="knowledge">知識</SelectItem>
                                            <SelectItem value="industry">產業</SelectItem>
                                            <SelectItem value="lifestyle">生活</SelectItem>
                                            <SelectItem value="region">地區</SelectItem>
                                            <SelectItem value="identity">身分</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>

                        {/* 背景處理 */}
                        {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">背景處理</Label>
                            <div className="space-y-2">
                                <Button size="sm" variant="outline" className="w-full">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    AI 智能去背
                                </Button>
                                <div className="grid grid-cols-2 gap-2">
                                    <div>
                                        <Label className="text-xs text-gray-600">背景選項</Label>
                                        <Select>
                                            <SelectTrigger className="mt-1">
                                                <SelectValue placeholder="選擇背景..." />
                                            </SelectTrigger>
                                            <SelectContent>
                                                <SelectItem value="transparent">透明背景</SelectItem>
                                                <SelectItem value="solid">純色背景</SelectItem>
                                                <SelectItem value="gradient">漸層背景</SelectItem>
                                                <SelectItem value="blur">模糊背景</SelectItem>
                                                <SelectItem value="custom">自訂背景</SelectItem>
                                            </SelectContent>
                                        </Select>
                                    </div>
                                    <div>
                                        <Label className="text-xs text-gray-600">背景色</Label>
                                        <div className="flex gap-2 mt-1">
                                            <div className="w-6 h-6 bg-white rounded border cursor-pointer"></div>
                                            <div className="w-6 h-6 bg-gray-200 rounded border cursor-pointer"></div>
                                            <div className="w-6 h-6 bg-blue-100 rounded border cursor-pointer"></div>
                                            <div className="w-6 h-6 bg-green-100 rounded border cursor-pointer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/* 濾鏡效果 */}
                        {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">濾鏡效果</Label>
                            <div className="grid grid-cols-4 gap-2">
                                <div className="text-center cursor-pointer hover:bg-gray-50 p-1 rounded">
                                    <div className="w-full aspect-square bg-gray-200 rounded mb-1"></div>
                                    <span className="text-xs">原始</span>
                                </div>
                                <div className="text-center cursor-pointer hover:bg-gray-50 p-1 rounded">
                                    <div className="w-full aspect-square bg-gray-300 rounded mb-1"></div>
                                    <span className="text-xs">黑白</span>
                                </div>
                                <div className="text-center cursor-pointer hover:bg-gray-50 p-1 rounded">
                                    <div className="w-full aspect-square bg-amber-100 rounded mb-1"></div>
                                    <span className="text-xs">復古</span>
                                </div>
                                <div className="text-center cursor-pointer hover:bg-gray-50 p-1 rounded">
                                    <div className="w-full aspect-square bg-blue-100 rounded mb-1"></div>
                                    <span className="text-xs">冷調</span>
                                </div>
                            </div>
                        </div> */}

                        {/* 照片調整 */}
                        {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">照片調整</Label>
                            <div className="space-y-3">
                                <div>
                                    <div className="flex justify-between">
                                        <Label className="text-xs text-gray-600">亮度</Label>
                                        <span className="text-xs text-gray-600">0</span>
                                    </div>
                                    <Input type="range" min="-100" max="100" defaultValue="0" className="mt-1" />
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <Label className="text-xs text-gray-600">對比度</Label>
                                        <span className="text-xs text-gray-600">0</span>
                                    </div>
                                    <Input type="range" min="-100" max="100" defaultValue="0" className="mt-1" />
                                </div>
                                <div>
                                    <div className="flex justify-between">
                                        <Label className="text-xs text-gray-600">飽和度</Label>
                                        <span className="text-xs text-gray-600">0</span>
                                    </div>
                                    <Input type="range" min="-100" max="100" defaultValue="0" className="mt-1" />
                                </div>
                            </div>
                        </div> */}

                        {/* 照片標註 */}
                        {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">照片標註</Label>
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="add-watermark" />
                                    <Label htmlFor="add-watermark" className="text-sm">
                                        添加浮水印
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="add-frame" />
                                    <Label htmlFor="add-frame" className="text-sm">
                                        添加相框
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="add-caption" />
                                    <Label htmlFor="add-caption" className="text-sm">
                                        添加文字說明
                                    </Label>
                                </div>
                                <Input placeholder="輸入文字說明..." className="mt-1" />
                            </div>
                        </div> */}

                        {/* AI 智能裁剪 */}
                        {/* <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Label className="text-sm font-medium">AI 智能裁剪</Label>
                                <Button size="sm" className="bg-blue-500 hover:bg-blue-600">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    智能裁剪
                                </Button>
                            </div>
                            <div className="grid grid-cols-3 gap-2">
                                <div className="text-center cursor-pointer hover:bg-gray-50 p-1 rounded">
                                    <div className="w-full aspect-square bg-gray-200 rounded mb-1"></div>
                                    <span className="text-xs">1:1</span>
                                </div>
                                <div className="text-center cursor-pointer hover:bg-gray-50 p-1 rounded">
                                    <div className="w-full aspect-video bg-gray-200 rounded mb-1"></div>
                                    <span className="text-xs">16:9</span>
                                </div>
                                <div className="text-center cursor-pointer hover:bg-gray-50 p-1 rounded">
                                    <div className="w-full h-12 bg-gray-200 rounded mb-1"></div>
                                    <span className="text-xs">4:3</span>
                                </div>
                            </div>
                            <p className="text-xs text-gray-500">AI 會自動識別主體並進行最佳裁剪</p>
                        </div> */}
                    </div>
                )

            case "video":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            影片 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                套用影片設定
                            </Button>
                        </h4>

                        {/* 上傳影片縮圖 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">上傳影片縮圖</Label>
                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-400 cursor-pointer">
                                <Video className="w-8 h-8 mx-auto mb-2 text-gray-400" />
                                <p className="text-sm text-gray-600">點擊上傳或拖拉影片縮圖</p>
                                <p className="text-xs text-gray-500">支援 JPG/PNG，建議比例 16:9</p>
                            </div>
                        </div>

                        {/* 影片類型選擇 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">影片類型選擇</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇影片類型..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="product">產品展示</SelectItem>
                                    <SelectItem value="tutorial">教學指南</SelectItem>
                                    <SelectItem value="testimonial">客戶見證</SelectItem>
                                    <SelectItem value="promotion">促銷活動</SelectItem>
                                    <SelectItem value="brand">品牌故事</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>



                        {/* 影片長度與格式 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">影片長度與格式</Label>
                            <div className="grid grid-cols-2 gap-2">
                                <div>
                                    <Label className="text-xs text-gray-600">建議長度</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇長度..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="short">短片 (15秒)</SelectItem>
                                            <SelectItem value="medium">中長 (30秒)</SelectItem>
                                            <SelectItem value="long">完整 (60秒)</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                <div>
                                    <Label className="text-xs text-gray-600">影片比例</Label>
                                    <Select>
                                        <SelectTrigger className="mt-1">
                                            <SelectValue placeholder="選擇比例..." />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="16:9">橫式 (16:9)</SelectItem>
                                            <SelectItem value="1:1">方形 (1:1)</SelectItem>
                                            <SelectItem value="9:16">直式 (9:16)</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                        </div>

                        {/* 影片風格建議 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">影片風格建議</Label>
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="fast-cuts" />
                                    <Label htmlFor="fast-cuts" className="text-sm">
                                        快速剪輯風格
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="text-overlay" />
                                    <Label htmlFor="text-overlay" className="text-sm">
                                        文字疊加效果
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="music-bg" />
                                    <Label htmlFor="music-bg" className="text-sm">
                                        背景音樂建議
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="captions" />
                                    <Label htmlFor="captions" className="text-sm">
                                        自動生成字幕
                                    </Label>
                                </div>
                            </div>
                        </div>
                        {/* AI 自動生成影片腳本 */}
                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Label className="text-sm font-medium">AI 自動生成影片腳本</Label>
                                <Button size="sm" className="bg-blue-500 hover:bg-blue-600">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    生成
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <p className="text-sm font-medium">春季新品展示</p>
                                    <p className="text-xs text-gray-600 mt-1">
                                        開場：春季色彩漸變效果
                                        <br />
                                        0:05-0:15：展示3款春季新品
                                        <br />
                                        0:15-0:25：特寫產品細節與材質
                                        <br />
                                        0:25-0:30：顯示折扣資訊與CTA
                                    </p>
                                </div>

                            </div>
                        </div>

                    </div>
                )

            case "hashtag":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            Hashtag AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600" onClick={applyAIResult}>
                                <Sparkles className="w-4 h-4 mr-2" />
                                套用標籤
                            </Button>
                        </h4>

                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Button className="w-full bg-green-500 hover:bg-green-600"
                                    onClick={() => {
                                        onFormFinish(form.getFieldsValue())
                                    }}>
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    生成
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <div
                                        className="text-sm"
                                        dangerouslySetInnerHTML={{ __html: aiReturnData?.output || '' }}
                                    />
                                    <span className="text-xs text-gray-500">{aiReturnData?.user_select_text}</span>
                                </div>
                            </div>
                        </div>
                        <BaseCanvasEdit_3_1_Form
                            propsForm={form}
                            // field
                            formReloadCount={0}
                            // propsOnValuesChange= () => { }
                            // defaultValue={}
                            onFormFinish={onFormFinish}
                            componentAttributesData={componentAttributesData.filter(item => item.is_ai === 1) || []}
                        />
                        <>
                            {/* 根據主題自動推薦 */}
                            {/* <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Label className="text-sm font-medium">根據主題自動推薦 #標籤（���多10個）</Label>
                                <Button size="sm" className="bg-blue-500 hover:bg-blue-600">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    推薦
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="flex flex-wrap gap-2">
                                    {["#春季新品", "#限時優惠", "#快時尚", "#SALE", "#折扣碼", "#搶購", "#新品上市", "#春天穿搭"].map(
                                        (tag) => (
                                            <span
                                                key={tag}
                                                className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full cursor-pointer hover:bg-blue-200"
                                            >
                                                {tag}
                                            </span>
                                        ),
                                    )}
                                </div>
                                <p className="text-xs text-gray-500">點擊標籤可移除，系統已根據「春季新品」主題推薦</p>
                            </div>
                        </div> */}

                            {/* 標籤類型篩選 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">標籤類型篩選</Label>
                            <div className="space-y-2">
                                <Label className="text-xs text-gray-600">行業類別</Label>
                                <Select>
                                    <SelectTrigger>
                                        <SelectValue placeholder="選擇行業..." />
                                    </SelectTrigger>
                                    <SelectContent>
                                        <SelectItem value="fashion">時尚服飾</SelectItem>
                                        <SelectItem value="beauty">美妝保養</SelectItem>
                                        <SelectItem value="ecommerce">電商零售</SelectItem>
                                        <SelectItem value="food">餐飲美食</SelectItem>
                                        <SelectItem value="lifestyle">生活風格</SelectItem>
                                        <SelectItem value="tech">科技3C</SelectItem>
                                    </SelectContent>
                                </Select>
                            </div>

                            <div className="space-y-2">
                                <Label className="text-xs text-gray-600">標籤風格</Label>
                                <div className="grid grid-cols-2 gap-2">
                                    <div className="flex items-center space-x-2">
                                        <Checkbox id="trending" />
                                        <Label htmlFor="trending" className="text-xs">
                                            熱門標籤
                                        </Label>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <Checkbox id="niche" />
                                        <Label htmlFor="niche" className="text-xs">
                                            小眾精準
                                        </Label>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <Checkbox id="brand" />
                                        <Label htmlFor="brand" className="text-xs">
                                            品牌相關
                                        </Label>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <Checkbox id="seasonal" />
                                        <Label htmlFor="seasonal" className="text-xs">
                                            季節性
                                        </Label>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                            {/* 自訂標籤 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">自訂標籤</Label>
                            <div className="flex gap-2">
                                <Input placeholder="輸入自訂標籤..." className="flex-1" />
                                <Button size="sm" variant="outline">
                                    新增
                                </Button>
                            </div>
                        </div> */}

                            {/* 標籤預覽 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">標籤預覽</Label>
                            <div className="p-3 bg-gray-50 rounded-lg">
                                <p className="text-sm text-gray-700">
                                    #春季新品 #限時優惠 #快時尚 #SALE #折扣碼 #搶購 #新品上市 #春天穿搭
                                </p>
                                <p className="text-xs text-gray-500 mt-1">共 8 個標籤</p>
                            </div>
                        </div> */}
                        </>
                    </div>
                )

            case "button":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            按鈕 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600" onClick={applyAIResult}>
                                <Sparkles className="w-4 h-4 mr-2" />
                                套用按鈕設定
                            </Button>
                        </h4>

                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Button className="w-full bg-green-500 hover:bg-green-600"
                                    onClick={() => {
                                        onFormFinish(form.getFieldsValue())
                                    }}>
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    生成
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <div
                                        className="text-sm"
                                        dangerouslySetInnerHTML={{ __html: aiReturnData?.output || '' }}
                                    />
                                    <span className="text-xs text-gray-500">{aiReturnData?.user_select_text}</span>
                                </div>
                            </div>
                        </div>
                        <BaseCanvasEdit_3_1_Form
                            propsForm={form}
                            // field
                            formReloadCount={0}
                            // propsOnValuesChange= () => { }
                            // defaultValue={}
                            onFormFinish={onFormFinish}
                            componentAttributesData={componentAttributesData.filter(item => item.is_ai === 1) || []}
                        />
                        <>
                            {/* 按鈕文字AI建議 */}
                            {/* <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Label className="text-sm font-medium">按鈕文字 AI 建議</Label>
                                <Button size="sm" className="bg-blue-500 hover:bg-blue-600">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    建議
                                </Button>
                            </div>

                            <div className="space-y-2">
                                <Label className="text-xs text-gray-600">按鈕用途</Label>
                                <Select>
                                    <SelectTrigger>
                                        <SelectValue placeholder="選擇按鈕用途..." />
                                    </SelectTrigger>
                                    <SelectContent>
                                        <SelectItem value="purchase">購買/下單</SelectItem>
                                        <SelectItem value="learn-more">了解更多</SelectItem>
                                        <SelectItem value="contact">聯絡我們</SelectItem>
                                        <SelectItem value="signup">註冊/加入</SelectItem>
                                        <SelectItem value="download">下載</SelectItem>
                                        <SelectItem value="share">分享</SelectItem>
                                    </SelectContent>
                                </Select>
                            </div>

                            <div className="space-y-2">
                                <Label className="text-xs text-gray-600">語氣風格</Label>
                                <Select>
                                    <SelectTrigger>
                                        <SelectValue placeholder="選擇語氣..." />
                                    </SelectTrigger>
                                    <SelectContent>
                                        <SelectItem value="urgent">急迫感（立即、馬上、搶購）</SelectItem>
                                        <SelectItem value="friendly">親切感（一起、來看看）</SelectItem>
                                        <SelectItem value="professional">專業感（了解、選購、諮詢）</SelectItem>
                                        <SelectItem value="fun">趣味感（GO、衝、讚）</SelectItem>
                                    </SelectContent>
                                </Select>
                            </div>
                        </div> */}



                            {/* 按鈕樣式建議 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">按鈕樣式建議</Label>
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="add-emoji-btn" />
                                    <Label htmlFor="add-emoji-btn" className="text-sm">
                                        加入 Emoji（🛒💰⚡）
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="add-arrow" />
                                    <Label htmlFor="add-arrow" className="text-sm">
                                        加入箭頭（→ ➤）
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="urgent-style" />
                                    <Label htmlFor="urgent-style" className="text-sm">
                                        急迫樣式（紅色背景）
                                    </Label>
                                </div>
                            </div>
                        </div> */}

                            {/* 自訂按鈕文字 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">自訂按鈕文字</Label>
                            <Input
                                placeholder="輸入自訂按鈕文字..."
                                value={canvasElement?.content}
                            />
                        </div> */}

                            {/* AI 建議結果 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">AI 建議結果</Label>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <p className="text-sm font-medium">立即搶購</p>
                                    <span className="text-xs text-gray-500">急迫感 + 購買用途</span>
                                </div>

                            </div>
                        </div> */}
                        </>
                    </div>
                )

            case "qrcode":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            QR Code AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600" onClick={applyAIResult}>
                                <Sparkles className="w-4 h-4 mr-2" />
                                代入 QR Code
                            </Button>
                        </h4>

                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Button className="w-full bg-green-500 hover:bg-green-600"
                                    onClick={() => {
                                        onFormFinish(form.getFieldsValue())
                                    }}>
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    生成
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <div
                                        className="text-sm"
                                        dangerouslySetInnerHTML={{ __html: aiReturnData?.output || '' }}
                                    />
                                    <span className="text-xs text-gray-500">{aiReturnData?.user_select_text}</span>
                                </div>
                            </div>
                        </div>
                        <BaseCanvasEdit_3_1_Form
                            propsForm={form}
                            // field
                            formReloadCount={0}
                            // propsOnValuesChange= () => { }
                            // defaultValue={}
                            onFormFinish={onFormFinish}
                            componentAttributesData={componentAttributesData.filter(item => item.is_ai === 1) || []}
                        />
                        <>
                            {/* 連結類型選擇 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">連結類型選擇</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇連結類型..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="website">網站連結</SelectItem>
                                    <SelectItem value="social">社群媒體</SelectItem>
                                    <SelectItem value="contact">聯絡資訊</SelectItem>
                                    <SelectItem value="wifi">WiFi 連線</SelectItem>
                                    <SelectItem value="app">App 下載</SelectItem>
                                    <SelectItem value="payment">付款連結</SelectItem>
                                </SelectContent>
                            </Select>
                        </div> */}

                            {/* 連結內容輸入 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">連結內容</Label>
                            <Input placeholder="輸入網址或內容..." />
                            <p className="text-xs text-gray-500">例如：https://example.com</p>
                        </div> */}

                            {/* AI 自動優化 */}
                            {/* <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Label className="text-sm font-medium">AI 自動優化</Label>
                                <Button size="sm" className="bg-blue-500 hover:bg-blue-600">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    優化
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="short-url" />
                                    <Label htmlFor="short-url" className="text-sm">
                                        自動縮短網址
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="track-analytics" />
                                    <Label htmlFor="track-analytics" className="text-sm">
                                        加入追蹤參數
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="error-correction" />
                                    <Label htmlFor="error-correction" className="text-sm">
                                        提高容錯率
                                    </Label>
                                </div>
                            </div>
                        </div> */}

                            {/* 樣式建議 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">樣式建議</Label>
                            <div className="grid grid-cols-2 gap-2">
                                <div className="p-3 border rounded cursor-pointer hover:bg-blue-50">
                                    <div className="w-12 h-12 bg-black mx-auto mb-2"></div>
                                    <span className="text-xs">經典黑白</span>
                                </div>
                                <div className="p-3 border rounded cursor-pointer hover:bg-blue-50">
                                    <div className="w-12 h-12 bg-blue-500 mx-auto mb-2"></div>
                                    <span className="text-xs">品牌色彩</span>
                                </div>
                            </div>
                        </div> */}
                        </>
                    </div>
                )

            case "datetime":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            日期時間 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600" onClick={applyAIResult}>
                                <Sparkles className="w-4 h-4 mr-2" />
                                套用時間設定
                            </Button>
                        </h4>

                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Button className="w-full bg-green-500 hover:bg-green-600"
                                    onClick={() => {
                                        onFormFinish(form.getFieldsValue())
                                    }}>
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    生成
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <div
                                        className="text-sm"
                                        dangerouslySetInnerHTML={{ __html: aiReturnData?.output || '' }}
                                    />
                                    <span className="text-xs text-gray-500">{aiReturnData?.user_select_text}</span>
                                </div>
                            </div>
                        </div>
                        <BaseCanvasEdit_3_1_Form
                            propsForm={form}
                            // field
                            formReloadCount={0}
                            // propsOnValuesChange= () => { }
                            // defaultValue={}
                            onFormFinish={onFormFinish}
                            componentAttributesData={componentAttributesData.filter(item => item.is_ai === 1) || []}
                        />
                        <>
                            {/* 時間類型選擇 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">時間類型選擇</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇時間類型..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="event-start">活動開始時間</SelectItem>
                                    <SelectItem value="event-end">活動結束時間</SelectItem>
                                    <SelectItem value="deadline">截止日期</SelectItem>
                                    <SelectItem value="countdown">倒數計時</SelectItem>
                                    <SelectItem value="schedule">時程安排</SelectItem>
                                </SelectContent>
                            </Select>
                        </div> */}

                            {/* 日期時間輸入 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">設定日期時間</Label>
                            <div className="grid grid-cols-2 gap-2">
                                <div>
                                    <Label className="text-xs text-gray-600">日期</Label>
                                    <Input type="date" className="mt-1" />
                                </div>
                                <div>
                                    <Label className="text-xs text-gray-600">時間</Label>
                                    <Input type="time" className="mt-1" />
                                </div>
                            </div>
                        </div> */}



                            {/* 顯示選項 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">顯示選項</Label>
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="show-timezone" />
                                    <Label htmlFor="show-timezone" className="text-sm">
                                        顯示時區
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="auto-update" />
                                    <Label htmlFor="auto-update" className="text-sm">
                                        自動更新倒數
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="add-calendar" />
                                    <Label htmlFor="add-calendar" className="text-sm">
                                        加入行事曆連結
                                    </Label>
                                </div>
                            </div>
                        </div> */}

                            {/* AI 智能建議 */}
                            {/* <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Label className="text-sm font-medium">AI 智能建議</Label>
                                <Button size="sm" className="bg-blue-500 hover:bg-blue-600">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    建議
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <p className="text-sm font-medium">⏰ 限時48小時</p>
                                    <span className="text-xs text-gray-500">急迫感倒數</span>
                                </div>
                            </div>
                        </div> */}
                        </>
                    </div>
                )

            case "location":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            地點資訊 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600" onClick={applyAIResult}>
                                <Sparkles className="w-4 h-4 mr-2" />
                                套用地點資訊
                            </Button>
                        </h4>

                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Button className="w-full bg-green-500 hover:bg-green-600"
                                    onClick={() => {
                                        onFormFinish(form.getFieldsValue())
                                    }}>
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    生成
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <div
                                        className="text-sm"
                                        dangerouslySetInnerHTML={{ __html: aiReturnData?.output || '' }}
                                    />
                                    <span className="text-xs text-gray-500">{aiReturnData?.user_select_text}</span>
                                </div>
                            </div>
                        </div>
                        <BaseCanvasEdit_3_1_Form
                            propsForm={form}
                            // field
                            formReloadCount={0}
                            // propsOnValuesChange= () => { }
                            // defaultValue={}
                            onFormFinish={onFormFinish}
                            componentAttributesData={componentAttributesData.filter(item => item.is_ai === 1) || []}
                        />
                        <>
                            {/* 地點類型選擇 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">地點類型選擇</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇地點類型..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="store">實體店面</SelectItem>
                                    <SelectItem value="event">活動場地</SelectItem>
                                    <SelectItem value="office">辦公地點</SelectItem>
                                    <SelectItem value="restaurant">餐廳美食</SelectItem>
                                    <SelectItem value="landmark">地標景點</SelectItem>
                                </SelectContent>
                            </Select>
                        </div> */}

                            {/* 地址輸入 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">地址資訊</Label>
                            <div className="space-y-2">
                                <Input placeholder="輸入地址或地點名稱..." />
                                <Button size="sm" variant="outline" className="w-full">
                                    <MapPin className="w-3 h-3 mr-1" />
                                    使用目前位置
                                </Button>
                            </div>
                        </div> */}



                            {/* 附加資訊 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">附加資訊</Label>
                            <div className="space-y-2">
                                <Input placeholder="電話號碼..." />
                                <Input placeholder="營業時間..." />
                                <Input placeholder="交通資訊..." />
                            </div>
                        </div> */}

                            {/* 地圖設定 */}
                            {/* <div className="space-y-3">
                            <Label className="text-sm font-medium">地圖設定</Label>
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="embed-map" />
                                    <Label htmlFor="embed-map" className="text-sm">
                                        嵌入地圖
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="directions-link" />
                                    <Label htmlFor="directions-link" className="text-sm">
                                        路線指引連結
                                    </Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="nearby-info" />
                                    <Label htmlFor="nearby-info" className="text-sm">
                                        附近景點資訊
                                    </Label>
                                </div>
                            </div>
                        </div> */}

                            {/* AI 地點建議 */}
                            {/* <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <Label className="text-sm font-medium">AI 地點建議</Label>
                                <Button size="sm" className="bg-blue-500 hover:bg-blue-600">
                                    <Sparkles className="w-3 h-3 mr-1" />
                                    搜尋
                                </Button>
                            </div>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <p className="text-sm font-medium">📍 台北101購物中心</p>
                                    <span className="text-xs text-gray-500">台北市信義區信義路五段7號</span>
                                </div>

                            </div>
                        </div> */}
                        </>
                    </div>
                )
            case "carousel":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            輪播元件 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                自動產生輪播內容
                            </Button>
                        </h4>

                        {/* 輪播類型選擇 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">輪播類型</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇輪播內容類型..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="image">圖片輪播</SelectItem>
                                    <SelectItem value="testimonial">用戶見證</SelectItem>
                                    <SelectItem value="steps">流程指引</SelectItem>
                                    <SelectItem value="highlight">活動亮點</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* 上傳內容 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">上傳輪播項目</Label>
                            <div className="space-y-2">
                                <Input placeholder="標題 / 說���文字" />
                                <Input type="file" />
                                <Button size="sm" variant="outline" className="w-full">
                                    新增一則項目
                                </Button>
                            </div>
                        </div>

                        {/* 輪播設定 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">播放設定</Label>
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="autoplay" />
                                    <Label htmlFor="autoplay" className="text-sm">自動播放</Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="loop" />
                                    <Label htmlFor="loop" className="text-sm">循環播放</Label>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Checkbox id="show-nav" />
                                    <Label htmlFor="show-nav" className="text-sm">顯示左右箭頭</Label>
                                </div>
                            </div>
                        </div>
                    </div>
                )

            case "form":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            表單元件 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                自動產生表單欄位
                            </Button>
                        </h4>

                        {/* 表單用途選擇 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">表單用途</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇表單用途..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="register">活動報名</SelectItem>
                                    <SelectItem value="contact">聯絡我們</SelectItem>
                                    <SelectItem value="feedback">意見回饋</SelectItem>
                                    <SelectItem value="trial">體驗申請</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* AI 欄位建議 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">AI 欄位建議</Label>
                            <div className="space-y-2">
                                <Input placeholder="姓名欄位" />
                                <Input placeholder="Email欄位" />
                                <Input placeholder="電話號碼欄位" />
                            </div>
                        </div>
                    </div>
                )

            case "faq":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            常見問答 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                一鍵產生常見問答
                            </Button>
                        </h4>

                        {/* 問答類型 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">問題類型</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇問題類型..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="payment">付款與退款</SelectItem>
                                    <SelectItem value="signup">報名與註冊</SelectItem>
                                    <SelectItem value="service">服務內容</SelectItem>
                                    <SelectItem value="policy">使用規則</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* AI 問答建議 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">AI 問答建議</Label>
                            <div className="space-y-2">
                                <div className="p-3 bg-gray-50 rounded-lg border cursor-pointer hover:bg-blue-50">
                                    <p className="text-sm font-medium">Q：可以取消訂單嗎？</p>
                                    <span className="text-xs text-gray-500">A：您可於出貨前隨時取消訂單。</span>
                                </div>

                            </div>
                        </div>
                    </div>
                )

            case "countdown":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            倒數計時器 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                快速設定倒數活動
                            </Button>
                        </h4>

                        {/* 倒數情境 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">倒數情境</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇倒數目的..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="signup">報名截止</SelectItem>
                                    <SelectItem value="launch">新品上線</SelectItem>
                                    <SelectItem value="sale">限時優惠</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* 到期時間 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">設定結束時間</Label>
                            <Input type="datetime-local" />
                        </div>

                        {/* 預覽區 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">預覽格式</Label>
                            <div className="p-4 border rounded-md bg-gray-50 text-center text-lg font-mono">
                                02 天 13 時 45 分 20 秒
                            </div>
                        </div>
                    </div>
                )

            case "steps":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            步驟流程 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                自動產出操作步驟
                            </Button>
                        </h4>

                        {/* 應用場景 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">流程場景</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇流程用途..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="signup">報名流程</SelectItem>
                                    <SelectItem value="purchase">購物流程</SelectItem>
                                    <SelectItem value="install">安裝教學</SelectItem>
                                    <SelectItem value="howto">操作說明</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* AI 步驟建議 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">AI 步驟建議</Label>
                            <div className="space-y-2">
                                <Input placeholder="步驟一：填寫基本資料" />
                                <Input placeholder="步驟二：確認付款資訊" />
                                <Input placeholder="步驟三：完成提交並查看通知" />
                            </div>
                        </div>
                    </div>
                )

            case "accordion":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            摺疊區塊 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                自動產出折疊內容
                            </Button>
                        </h4>

                        {/* 類型選擇 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">使用場景</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇內容類型..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="faq">常見問答</SelectItem>
                                    <SelectItem value="agenda">活動議程</SelectItem>
                                    <SelectItem value="detail">詳細說明</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* AI 建議項目 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">AI 建議項目</Label>
                            <div className="space-y-2">
                                <Input placeholder="折疊標題 1" />
                                <Textarea placeholder="對應內容說明..." />
                                <Input placeholder="折疊標題 2" />
                                <Textarea placeholder="對應內容說明..." />
                            </div>
                        </div>
                    </div>
                )

            case "timeline":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            時間軸 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                自動產出歷程節點
                            </Button>
                        </h4>

                        {/* 時間軸類型 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">時間軸用途</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇應用情境..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="history">品牌歷史</SelectItem>
                                    <SelectItem value="flow">服務流程</SelectItem>
                                    <SelectItem value="project">專案進度</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* 節點內容 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">AI 節點建議</Label>
                            <div className="space-y-2">
                                <Input placeholder="2020 年 - 品牌成立" />
                                <Input placeholder="2022 年 - 獲得首筆融資" />
                                <Input placeholder="2025 年 - 全球拓展" />
                            </div>
                        </div>
                    </div>
                )

            case "map-embed":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            地圖嵌入 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                一鍵插入 Google Maps
                            </Button>
                        </h4>

                        {/* 地圖型態 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">地圖用途</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇用途類型..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="store">門市地圖</SelectItem>
                                    <SelectItem value="event">活動場地</SelectItem>
                                    <SelectItem value="multi">多據點展示</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* 輸入地點 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">輸入地點</Label>
                            <Input placeholder="輸入地址或地標..." />
                        </div>

                        {/* 顯示設定 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">顯示設定</Label>
                            <div className="space-y-2">
                                <Checkbox id="zoom-control" />
                                <Label htmlFor="zoom-control" className="text-sm">顯示縮放控制</Label>
                            </div>
                            <div className="space-y-2">
                                <Checkbox id="map-marker" />
                                <Label htmlFor="map-marker" className="text-sm">顯示標記點</Label>
                            </div>
                        </div>
                    </div>
                )

            case "broadcast":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            輸播元件 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                產生滾動訊息
                            </Button>
                        </h4>

                        {/* 輸播用途 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">用途類型</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇輸播內容類型..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="promotion">限時優惠</SelectItem>
                                    <SelectItem value="news">公告訊息</SelectItem>
                                    <SelectItem value="event">活動提醒</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* 輸播文字輸入 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">滾動訊息內容</Label>
                            <Textarea placeholder="輸入要持續滾動的簡短文字內容..." />
                        </div>

                        {/* 設定項目 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">效果設定</Label>
                            <div className="space-y-2">
                                <Checkbox id="loop" />
                                <Label htmlFor="loop" className="text-sm">循環播放</Label>
                            </div>
                            <div className="space-y-2">
                                <Checkbox id="clickable" />
                                <Label htmlFor="clickable" className="text-sm">點擊可連結</Label>
                            </div>
                        </div>
                    </div>
                )

            case "floating-nav":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            浮動導覽 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                建議導覽節點
                            </Button>
                        </h4>

                        {/* 位置設定 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">顯示位置</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="選擇浮動按鈕位置..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="bottom-right">右下角</SelectItem>
                                    <SelectItem value="bottom-left">左下角</SelectItem>
                                    <SelectItem value="top-right">右上角</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* 導覽項目輸入 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">導覽節點名稱</Label>
                            <div className="space-y-2">
                                <Input placeholder="導覽項目 1（例如：方案特色）" />
                                <Input placeholder="導覽項目 2（例如：價格表）" />
                            </div>
                        </div>

                        {/* 額外選項 */}
                        <div className="space-y-3">
                            <Checkbox id="scroll-top" />
                            <Label htmlFor="scroll-top" className="text-sm">顯示「回頂部」按鈕</Label>
                        </div>
                    </div>
                )

            case "anchor-nav":
                return (
                    <div className="space-y-6">
                        <h4 className="font-medium text-gray-900 flex items-center gap-2">
                            <Sparkles className="w-4 h-4" />
                            錨點導航 AI 工具
                            <Button className="w-full bg-blue-500 hover:bg-blue-600">
                                <Sparkles className="w-4 h-4 mr-2" />
                                自動產生錨點列表
                            </Button>
                        </h4>

                        {/* 錨點來源分析 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">頁面分析來源</Label>
                            <Select>
                                <SelectTrigger>
                                    <SelectValue placeholder="分析頁面哪一部分產錨點？" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="heading">標題 (H2/H3)</SelectItem>
                                    <SelectItem value="section">段落區塊</SelectItem>
                                    <SelectItem value="custom">自定義區塊</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>

                        {/* 錨點項目輸入 */}
                        <div className="space-y-3">
                            <Label className="text-sm font-medium">導覽項目設定</Label>
                            <div className="space-y-2">
                                <Input placeholder="錨點項目 1：服務說明" />
                                <Input placeholder="錨點項目 2：使用教學" />
                            </div>
                        </div>

                        {/* 位置選項 */}
                        <div className="space-y-3">
                            <Checkbox id="sticky-top" />
                            <Label htmlFor="sticky-top" className="text-sm">固定在畫面上方</Label>
                        </div>
                    </div>
                )

            default:
                return (
                    <div className="text-center text-gray-500 mt-8">
                        <Sparkles className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                        <p>選擇一個元件來使用 AI 工具</p>
                    </div>
                )
        }
    }
    const getSettingToolForComponent = ({ element, componentType }) => {
        //form_form_column_data 的 first value

        let form_form_column_data = element?.form_form_column_data || []
        let form_form_column_data_value = form_form_column_data.find((e) => true)
        let default_form_setting_tool_value = {
            // "form_column_id": 2,
            "code": "",
            "is_required": 0,
            "default_value": "",
            "placeholder": "",
            "help_text": "",
            // "index": 2,
            // "create_user_id": 215,
            // "create_user_name": "最高權限管理員",
            // "create_time": "2025-08-26",
            // "last_edit_user_id": 215,
            // "last_edit_user_name": "最高權限管理員",
            // "last_edit_time": "2025-08-26",
            // "form_column_component_definitions_data": [
            //     {
            //         "form_column_component_definition_id": 2,
            //         "component_definitions_id": 85,
            //         "component_type": "checkbox",
            //         "icon": "<CheckSquare className=\"w-4 h-4\" />",
            //         "sub_icon": null,
            //         "description": "勾選框",
            //         "component_definitions_classify_structure_type_data": [
            //             {
            //                 "component_definitions_classify_structure_type_id": 81,
            //                 "classify_structure_type_id": 31306,
            //                 "name_language_data": [
            //                     {
            //                         "language_manage_id": 6054,
            //                         "language_culture_code": "zh-tw",
            //                         "language_culture_value": "勾選框"
            //                     }
            //                 ]
            //             }
            //         ],
            //         "last_edit_time": "2025-08-24"
            //     }
            // ],
            "form_column_validation_data": [
                {
                    // "form_column_validation_id": 2,
                    // "validation_id": 2,
                    "format": null,
                    "format_regex": null,
                    "max_text_number": 99,
                    "min_text_number": 0,
                    "min_value": 0,
                    "max_value": 999,
                    "disable_special_character": 0,
                    "only_allow_chinese": 0,
                    "only_allow_english": 0,
                    "wrong_message": null,
                    "validation_classify_structure_type_data": [
                        {
                            // "validation_classify_structure_type_id": 2,
                            // "classify_structure_type_id": 31369,
                            "name_language_data": [
                                {
                                    // "language_manage_id": 6087,
                                    "language_culture_code": "zh-tw",
                                    "language_culture_value": ""
                                }
                            ]
                        }
                    ],
                    "validation_selection_option_data": [
                        {
                            // "validation_selection_option_id": 2,
                            // "selection_option_id": 95,
                            "selection_option_classify_structure_type_data": [
                                {
                                    // "selection_option_classify_structure_type_id": 95,
                                    // "classify_structure_type_id": 31373,
                                    "name_language_data": [
                                        {
                                            // "language_manage_id": 6091,
                                            "language_culture_code": "zh-tw",
                                            "language_culture_value": null
                                        }
                                    ]
                                }
                            ],
                            // "classify_structure_type_parent_id": 0,
                            // "selection_option_parent_id": null
                        }
                    ],
                    "form_column_selection_option_data": [
                        {
                            // "form_column_selection_option_id": 2,
                            // "selection_option_id": 92,
                            "selection_option_classify_structure_type_data": [
                                {
                                    // "selection_option_classify_structure_type_id": 92,
                                    // "classify_structure_type_id": 31366,
                                    "name_language_data": [
                                        {
                                            // "language_manage_id": 6084,
                                            "language_culture_code": "zh-tw",
                                            "language_culture_value": null
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                }
            ],
            "form_column_selection_option_data": []
        }
        if (!!form_form_column_data_value) {
            // form_setting_tool.resetFields({ ...form_form_column_data_value })
            form_setting_tool.setFieldsValue({
                ...form_form_column_data_value
            })
        }
        else {
            form_setting_tool.resetFields({ ...default_form_setting_tool_value })
            // form_setting_tool.setFieldsValue({
            //     ...default_form_setting_tool_value
            // })
            // onChangecanvasElement(default_form_setting_tool_value, 'form_form_column_data');
        }
        console.log({ default_form_setting_tool_value, form_form_column_data_value })
        return (
            <BaseCanvasEdit_3_1_SettingToolForm
                propsForm={form_setting_tool}
                element={element}
                componentType={componentType}
                propsOnValuesChange={(values) => {
                    onChangecanvasElement(values, 'form_form_column_data');
                }}
                documentFiveWAPI={documentFiveWAPI}
                fiveWResponseAPI={fiveWResponseAPI}
                five_w_id={five_w_id}
                documentController={documentController}
                dropDownDocumentController={dropDownDocumentController}
                dropDownDocumentAPiRoute={dropDownDocumentAPiRoute}
            />
        )
    }
    function updateInnerFormColumnData(element, newFormFormColumnData) {
        // 深拷貝一份 element，避免直接修改原物件引用
        let newElement;
        try {
            newElement = element ? JSON.parse(JSON.stringify(element)) : {};
        } catch (e) {
            // 若無法 clone，退回到淺拷貝
            newElement = { ...(element || {}) };
        }

        // 建構必要的階層結構：
        // form_form_column_data[0] -> form_column_source_data[0] -> document_source_data[0] -> document_source_data[0] -> document_form_data[0] -> form_form_column_data

        if (!Array.isArray(newElement.form_form_column_data)) newElement.form_form_column_data = [{}];
        if (!newElement.form_form_column_data[0]) newElement.form_form_column_data[0] = {};

        const ff = newElement.form_form_column_data[0];

        if (!Array.isArray(ff.form_column_source_data)) ff.form_column_source_data = [{}];
        if (!ff.form_column_source_data[0]) ff.form_column_source_data[0] = {};

        const fcs = ff.form_column_source_data[0];
        if (!Array.isArray(fcs.document_source_data)) fcs.document_source_data = [{}];
        if (!fcs.document_source_data[0]) fcs.document_source_data[0] = {};

        const ds = fcs.document_source_data[0];
        if (!Array.isArray(ds.document_source_data)) ds.document_source_data = [{}];
        if (!ds.document_source_data[0]) ds.document_source_data[0] = {};

        const ds2 = ds.document_source_data[0];
        if (!Array.isArray(ds2.document_form_data)) ds2.document_form_data = [{}];
        if (!ds2.document_form_data[0]) ds2.document_form_data[0] = {};

        // 最內層直接覆寫 form_form_column_data（若傳入為 null/undefined，轉為空陣列）
        ds2.document_form_data[0].form_form_column_data = Array.isArray(newFormFormColumnData) ? newFormFormColumnData : [];

        return newElement;
    }


    const AiProduceController = useCRUDController({
        apiRoute: aiGenerateAPIRoute,
        onFinish,
    })
    const five_w_setting_documentController = useCRUDController({
        apiRoute: "/process_management/backend/five_w_setting_document/view",
        onFinish: ({ axiosMode, status, values }) => { },
        onBefore: () => { },
    });
    useEffect(() => {
        five_w_setting_documentController.getData()
            .then((res) => {
                let data = res?.data || [];
                let documentData = data?.find((ele) => ele?.document_name === "欄位人事時地物")
                let document_classify_structure_type_data = documentData?.document_classify_structure_type_data || []
                let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((e) => true)
                let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
                let document_form_data_first = document_form_data?.find((e) => true)
                let form_form_column_data = document_form_data_first?.form_form_column_data || []
                setElementFiveWFormFormColumnData(form_form_column_data);
            })
    }, [])
    return (
        <div className="w-80 bg-white border-l border-gray-200">
            <Tabs defaultValue={showTabkey[0]} className="h-full flex flex-col">
                <TabsList className={`grid w-full grid-cols-${showTabkey?.length} m-4`}>
                    {showTabkey.includes("setting_tool") && <TabsTrigger value="setting_tool">設定工具</TabsTrigger>}
                    {showTabkey.includes("properties") && <TabsTrigger value="properties">元件屬性</TabsTrigger>}
                    {showTabkey.includes("ai") && <TabsTrigger value="ai">AI工具</TabsTrigger>}
                    {showTabkey.includes("step_setting") && <TabsTrigger value="step_setting">步驟設定</TabsTrigger>}
                </TabsList>
                <TabsContent value="properties" className="flex-1 p-4 space-y-4 overflow-y-auto">
                    {selectedComponentId ? (
                        <>
                            <div className="flex items-center gap-2 mb-4">
                                <Type className="w-4 h-4" />
                                <span className="font-medium">{canvasElement?.content}</span>
                                <div className="ml-auto flex gap-1">
                                    <Button variant="ghost" size="sm">
                                        <Move className="w-4 h-4" />
                                    </Button>
                                    <Button variant="ghost" size="sm">
                                        <RotateCcw className="w-4 h-4" />
                                    </Button>
                                </div>
                            </div>
                            <ComponentProperties
                                element={canvasElement}
                                componentCommonAttributesData={componentCommonAttributesData || []}
                                componentAttributesData={componentAttributesData || []}
                                selectElementId={selectElementId}
                                handleComponentEffect={handleComponentEffect}
                            />
                            {/* {getComponentProperties(componentAttributesData || [])} */}
                        </>
                    ) : (
                        <div className="text-center text-gray-500 mt-8">
                            <Type className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                            <p>選擇一個元件來編輯屬性</p>
                        </div>
                    )}
                </TabsContent>
                <TabsContent value="ai" className="flex-1 p-4 overflow-y-auto">
                    {selectedComponentId ? (
                        <div className="space-y-6">{getAIToolsForComponent(elementData.component_type)}</div>
                    ) : (
                        <div className="text-center text-gray-500 mt-8">
                            <Sparkles className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                            <p>選擇一個元件來使用 AI 工具</p>
                        </div>
                    )}
                </TabsContent>
                <TabsContent value="setting_tool" className="flex-1 p-4 overflow-y-auto">
                    {/* 選擇哪一個元件來編輯設定 */}
                    {selectElementId ? (
                        <div className="space-y-6">
                            <SettingTool
                                selectElementId={selectElementId}
                                selectedComponentId={selectedComponentId}
                                element={canvasElement}
                                componentType={canvasElement?.type}
                                key={selectElementId}
                                onChangecanvasElement={onChangecanvasElement}
                                dropDownDocumentController={dropDownDocumentController}
                                dropDownDocumentAPiRoute={dropDownDocumentAPiRoute}
                                fiveWResponseAPI={fiveWResponseAPI}
                                documentFiveWAPI={documentFiveWAPI}
                                five_w_id={five_w_id}
                                elementsData={elementsData || []}
                            />
                        </div>
                    ) : (
                        <div className="text-center text-gray-500 mt-8">
                            <Sparkles className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                            <p>選擇一個元件來編輯設定</p>
                        </div>
                    )}
                </TabsContent>
                {showTabkey.includes("step_setting") && <TabsContent value="step_setting" className="flex-1 p-4 overflow-y-auto">
                    {/* 選擇哪一個步驟進行設定 */}
                    {selectedComponentId ? (
                        <div className="space-y-6">
                            <StepSetting
                                element={canvasElement}
                                componentType={elementData?.component_type}
                                onChangecanvasElement={onChangecanvasElement}
                                // base_form_form_column_data={elementFiveWFormFormColumnData}
                                baseDisplayDocumentValue={five_w_setting_documentController.ResponseData?.find((ele) => ele?.document_name === "欄位人事時地物") || {}}
                                fiveWResponseData={fiveWResponseData}
                                allDocumentData={allDocumentData}
                            />
                        </div>
                    ) : (
                        <div className="text-center text-gray-500 mt-8">
                            <Sparkles className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                            <p>選擇一個步驟進行設定</p>
                        </div>
                    )}
                </TabsContent>}
            </Tabs>
        </div>
    )
}
const SettingTool = ({
    element,
    componentType,
    selectedComponentId,
    onChangecanvasElement,
    dropDownDocumentController,
    dropDownDocumentAPiRoute,
    selectElementId,
    fiveWResponseAPI,
    documentFiveWAPI,
    five_w_id,
    elementsData = []
}) => {
    const [form_setting_tool] = Form.useForm();

    useEffect(() => {
        //form_form_column_data 的 first value

        let form_form_column_data = element?.form_form_column_data || []
        let form_form_column_data_value = form_form_column_data.find((e) => true)
        let default_form_setting_tool_value = {
            // "form_column_id": 2,
            "code": "",
            "is_required": 0,
            "default_value": "",
            "placeholder": "",
            "help_text": "",
            // "index": 2,
            // "create_user_id": 215,
            // "create_user_name": "最高權限管理員",
            // "create_time": "2025-08-26",
            // "last_edit_user_id": 215,
            // "last_edit_user_name": "最高權限管理員",
            // "last_edit_time": "2025-08-26",
            // "form_column_component_definitions_data": [
            //     {
            //         "form_column_component_definition_id": 2,
            //         "component_definitions_id": 85,
            //         "component_type": "checkbox",
            //         "icon": "<CheckSquare className=\"w-4 h-4\" />",
            //         "sub_icon": null,
            //         "description": "勾選框",
            //         "component_definitions_classify_structure_type_data": [
            //             {
            //                 "component_definitions_classify_structure_type_id": 81,
            //                 "classify_structure_type_id": 31306,
            //                 "name_language_data": [
            //                     {
            //                         "language_manage_id": 6054,
            //                         "language_culture_code": "zh-tw",
            //                         "language_culture_value": "勾選框"
            //                     }
            //                 ]
            //             }
            //         ],
            //         "last_edit_time": "2025-08-24"
            //     }
            // ],
            "form_column_validation_data": [
                {
                    // "form_column_validation_id": 2,
                    // "validation_id": 2,
                    "format": null,
                    "format_regex": null,
                    "max_text_number": 99,
                    "min_text_number": 0,
                    "min_value": 0,
                    "max_value": 999,
                    "disable_special_character": 0,
                    "only_allow_chinese": 0,
                    "only_allow_english": 0,
                    "wrong_message": null,
                    "validation_classify_structure_type_data": [
                        {
                            // "validation_classify_structure_type_id": 2,
                            // "classify_structure_type_id": 31369,
                            "name_language_data": [
                                {
                                    // "language_manage_id": 6087,
                                    "language_culture_code": "zh-tw",
                                    "language_culture_value": ""
                                }
                            ]
                        }
                    ],
                    "validation_selection_option_data": [
                        {
                            // "validation_selection_option_id": 2,
                            // "selection_option_id": 95,
                            "selection_option_classify_structure_type_data": [
                                {
                                    // "selection_option_classify_structure_type_id": 95,
                                    // "classify_structure_type_id": 31373,
                                    "name_language_data": [
                                        {
                                            // "language_manage_id": 6091,
                                            "language_culture_code": "zh-tw",
                                            "language_culture_value": null
                                        }
                                    ]
                                }
                            ],
                            // "classify_structure_type_parent_id": 0,
                            // "selection_option_parent_id": null
                        }
                    ],
                    "form_column_selection_option_data": [
                        {
                            // "form_column_selection_option_id": 2,
                            // "selection_option_id": 92,
                            "selection_option_classify_structure_type_data": [
                                {
                                    // "selection_option_classify_structure_type_id": 92,
                                    // "classify_structure_type_id": 31366,
                                    "name_language_data": [
                                        {
                                            // "language_manage_id": 6084,
                                            "language_culture_code": "zh-tw",
                                            "language_culture_value": null
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                }
            ],
            "form_column_selection_option_data": []
        }
        console.log({ form_form_column_data_value });
        if (!!form_form_column_data_value) {
            // form_setting_tool.resetFields({ ...form_form_column_data_value })
            form_setting_tool.resetFields({
                ...form_form_column_data_value
            })

        }
        else {
            form_setting_tool.resetFields({ ...default_form_setting_tool_value })
            // form_setting_tool.setFieldsValue({
            //     ...default_form_setting_tool_value
            // })
            // onChangecanvasElement(default_form_setting_tool_value, 'form_form_column_data');
        }
    }, [selectElementId])
    return (
        <>
            <BaseCanvasEdit_3_1_SettingToolForm
                key={selectElementId}
                propsForm={form_setting_tool}
                element={element}
                componentType={componentType}
                propsOnValuesChange={(values) => {
                    onChangecanvasElement(values, 'form_form_column_data');
                }}
                dropDownDocumentController={dropDownDocumentController}
                dropDownDocumentAPiRoute={dropDownDocumentAPiRoute}
                documentFiveWAPI={documentFiveWAPI}
                fiveWResponseAPI={fiveWResponseAPI}
                five_w_id={five_w_id}
                elementsData={elementsData}
            />
        </>
    )
}
const ComponentProperties = ({
    element,
    selectElementId,
    componentAttributesData,
    componentCommonAttributesData,
    handleComponentEffect = () => { }
}) => {

    return (
        <div>
            <div className="space-y-6">
                <div className="space-y-4">
                    <h4 className="font-medium text-gray-900 border-b pb-2">通用樣式屬性</h4>
                    {/* 通用樣式屬性 */}
                    {
                        componentCommonAttributesData
                            ?.filter((component) => !component?.is_ai && !!component?.is_default)
                            ?.map((component, index) => {
                                // same judgement as commonProperties: skip AI attrs and require is_default === 1
                                return (
                                    <PropertiesRenderer
                                        key={"default_" + index}
                                        component={component}
                                        index={index}
                                        element={element}
                                        handleComponentEffect={handleComponentEffect}
                                    />
                                );
                            })
                    }
                </div>
                <div className="space-y-4">
                    <h4 className="font-medium text-gray-900 border-b pb-2">元件屬性</h4>
                    {/* 專屬樣式屬性 */}
                    {
                        componentAttributesData
                            ?.filter((component) => !component?.is_ai && !component?.is_default)
                            ?.map((component, index) => (
                                <PropertiesRenderer
                                    key={index}
                                    component={component}
                                    index={index}
                                    element={element}
                                    handleComponentEffect={handleComponentEffect}
                                />
                            ))
                    }

                </div>

            </div>
        </div>
    )
}
const PropertiesRenderer = ({
    component,
    index,
    handleComponentEffect = () => { },
    element
}) => {
    // 根據 componentAttributesData 動態渲染屬性編輯介面
    // return (<> </>)
    return (
        <div>
            {component?.component_type === "SELECT" &&
                <div key={index}>
                    <Label className="text-sm font-medium">
                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                    </Label>
                    <Select
                        value={component?.propety_json?.group_name ? element?.[component?.propety_json?.group_name]?.[component?.propety_json?.attribute_css] : element?.[component?.propety_json?.attribute_css]}
                        onValueChange={(value) => { handleComponentEffect(value, component, component?.propety_json?.group_name) }}>
                        <SelectTrigger className="mt-1">
                            <SelectValue placeholder={component?.propety_json?.placeholder ?? ""} />
                        </SelectTrigger>
                        <SelectContent>
                            {component?.propety_option_json?.data?.map((option) => (
                                <SelectItem key={option?.value} value={option?.value}>
                                    {option?.label}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            }
            {component?.component_type === "CHECKBOX" &&
                <div key={index}>
                    <Label className="text-sm font-medium">
                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                    </Label>
                    <div className="flex items-center space-x-2">
                        <Checkbox id="image-border"
                            checked={component?.propety_json?.group_name ? element?.[component?.propety_json?.group_name]?.[component?.propety_json?.attribute_css] : element?.[component?.propety_json?.attribute_css]}
                            onCheckedChange={(value) => {
                                handleComponentEffect(value, component, component?.propety_json?.group_name)
                            }}
                        />
                        <Label htmlFor="image-border" className="text-sm">
                            {component?.propety_json?.placeholder ?? ""}
                        </Label>
                    </div>
                </div>
            }
            {component?.component_type === "INPUT" &&
                <div key={index}>
                    <Label className="text-sm font-medium">
                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                    </Label>
                    <Input
                        type="text"
                        placeholder={component?.propety_json?.placeholder ?? ""}
                        className="mt-1"
                        value={component?.propety_json?.group_name ? (element?.[component?.propety_json?.group_name]?.[component?.propety_json?.attribute_css] || "") : (element?.[component?.propety_json?.attribute_css] || "")}
                        onChange={(e) => {
                            handleComponentEffect(e.target.value, component, component?.propety_json?.group_name)
                        }}
                    />
                </div>
            }
            {component?.component_type === "COLOR_PICKER" &&
                <div key={index}>
                    <div>
                        <Label className="text-sm font-medium">
                            {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                        </Label>
                        <div className="flex gap-2 mt-1">
                            {component?.propety_option_json?.data?.map((option) => (
                                <div
                                    className="w-8 h-8 rounded border cursor-pointer"
                                    style={{ backgroundColor: option?.value }}
                                    onClick={() => { handleComponentEffect(option?.value, component, component?.propety_json?.group_name) }}
                                ></div>
                            ))}
                        </div>
                    </div>
                </div>
            }
            {component?.component_type === "COLOR_PICKER2" &&
                <div key={index}>
                    <div>
                        <Label className="text-sm font-medium">
                            {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                        </Label>
                        <div className="flex gap-2">
                            <Input
                                type="color"
                                value={component?.propety_json?.group_name ? element?.[component?.propety_json?.group_name]?.[component?.propety_json?.attribute_css] : element?.[component?.propety_json?.attribute_css]}
                                onChange={(e) => {
                                    handleComponentEffect(e.target.value, component, component?.propety_json?.group_name)
                                }}
                                className="h-9 w-16 p-1 cursor-pointer"
                            />
                            <Input
                                type="text"
                                value={component?.propety_json?.group_name ? element?.[component?.propety_json?.group_name]?.[component?.propety_json?.attribute_css] : element?.[component?.propety_json?.attribute_css]}
                                onChange={(e) => {
                                    handleComponentEffect(e.target.value, component, component?.propety_json?.group_name)
                                }}
                                placeholder="#000000"
                                className="h-9 flex-1 text-sm"
                            />
                        </div>
                    </div>
                </div>
            }
            {component?.component_type === "INPUT_NUMBER" &&
                <div key={index}>
                    <Label className="text-sm font-medium">
                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                    </Label>
                    <Input
                        type="number"
                        placeholder={component?.propety_json?.placeholder ?? ""}
                        className="mt-1"
                        value={component?.propety_json?.group_name ? element?.[component?.propety_json?.group_name]?.[component?.propety_json?.attribute_css] : element?.[component?.propety_json?.attribute_css]}
                        onChange={(e) => {
                            handleComponentEffect(e.target.value, component, component?.propety_json?.group_name)
                        }}
                    />
                </div>
            }
            {component?.component_type === "BUTTON_GROUP" &&
                <div key={index}>
                    <Label className="text-sm font-medium">
                        {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                    </Label>
                    <div className="mt-2 flex space-x-2">
                        {component?.propety_option_json?.data?.map((option) => {
                            let selectValue = component?.propety_json?.group_name ? element?.[component?.propety_json?.group_name]?.[component?.propety_json?.attribute_css] : element?.[component?.propety_json?.attribute_css]
                            return (
                                <Button
                                    key={option?.value}
                                    variant={selectValue === option?.value ? "default" : "outline"}
                                    onClick={() => { handleComponentEffect(option?.value, component, component?.propety_json?.group_name) }}
                                >
                                    <LucideIcon name={option?.icon} className="w-4 h-4" /> {option?.label}
                                </Button>
                            )
                        })}
                    </div>
                </div>
            }
            {
                component?.component_type === "CHECKBOX_SWITCH" &&
                (
                    <div className="flex items-center justify-between p-3 rounded-md border">
                        <Label className="text-sm cursor-pointer">
                            {component?.component_attributes_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value ?? ""}
                        </Label>
                        <Checkbox
                            checked={component?.propety_json?.group_name ? element?.[component?.propety_json?.group_name]?.[component?.propety_json?.attribute_css] : element?.[component?.propety_json?.attribute_css]}
                            onCheckedChange={(value) => {
                                handleComponentEffect(value, component, component?.propety_json?.group_name)
                            }}
                        />
                    </div>
                )
            }
        </div>
    )
};
const StepSetting = ({
    element,
    componentType,
    onChangecanvasElement,
    baseDisplayDocumentValue = null,
    fiveWResponseData = [],
    allDocumentData = []
    // base_form_form_column_data = []
}) => {
    const [displayDocumentValue, setDisplayDocumentValue] = useState(null);
    const [form_form_column_data, setFormFormColumnData] = useState([]);

    const getDocumnetFormFormColumnData = (documentValue) => {
        // let 
    }
    const getSampleData = (element) => {
        let form_form_column_data = element?.form_form_column_data || [];
        let form_column_source_data = form_form_column_data?.[0]?.form_column_source_data || [];
        let document_source_data = form_column_source_data?.[0]?.document_source_data || [];
        let sample_data = document_source_data?.[0]?.sample_data || [];
        return sample_data;
    }
    const getElement5wFormColumns = (element) => {
        // 只搜尋位於 sample_data 裡面的 response_form_value_data，並回傳扁平化陣列
        const out = [];
        const root = element?.form_form_column_data || [];

        // 在 sample_data 範圍內遞迴尋找 response_form_value_data
        const collectInSample = (node) => {
            if (!node) return;
            if (Array.isArray(node)) {
                node.forEach((n) => collectInSample(n));
                return;
            }
            if (typeof node === 'object') {
                for (const key of Object.keys(node)) {
                    if (key === 'response_form_value_data' && Array.isArray(node[key])) {
                        out.push(...node[key]);
                    } else {
                        collectInSample(node[key]);
                    }
                }
            }
        };

        // 遍歷 root，當遇到 sample_data 時，對每個 sample item 執行 collectInSample
        const traverse = (node) => {
            if (!node) return;
            if (Array.isArray(node)) {
                node.forEach((n) => traverse(n));
                return;
            }
            if (typeof node === 'object') {
                for (const key of Object.keys(node)) {
                    if (key === 'sample_data' && Array.isArray(node[key])) {
                        node[key].forEach((sample) => collectInSample(sample));
                    } else {
                        traverse(node[key]);
                    }
                }
            }
        };

        traverse(root);
        return out;
    }
    // let form_form_column_data = get5wFormColumns(element) || [];
    let fiveWDataTemp = transformFormColumnDataToFiveWData(form_form_column_data)




    const updatedElementFormFormColumnData = (element, changedFormColumnData) => {
        console.log({ element, changedFormColumnData });

        // 預設模板結構
        const form_form_column_data_sample = [
            {
                "code": element?.title || element?.id,
                "index": 1,
                "help_text": "",
                "is_required": 0,
                "placeholder": null,
                "default_value": null,
                "form_column_edge_data": [],
                "form_column_source_data": [
                    {
                        "document_source_data": [
                            {
                                "sample_data": [
                                    {
                                        "document_id": baseDisplayDocumentValue?.document_id,
                                        "document_response_data": [
                                            {
                                                "document_response_data": [
                                                    {
                                                        "document_id": 1
                                                    }
                                                ],
                                                "response_form_value_data": changedFormColumnData
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "form_column_five_w_sub_data": [],
                "form_column_validation_data": [],
                "form_column_selection_option_data": [],
                "form_column_component_definition_data": [
                    {
                        "component_definition_id": element?.component_definitions_id
                    }
                ]
            }
        ];

        // 如果 element 沒有 form_form_column_data 或為空，返回預設模板
        if (!element?.form_form_column_data || element.form_form_column_data.length === 0) {
            return form_form_column_data_sample;
        }

        // 深拷貝現有資料，避免直接修改原始 element
        const updatedData = JSON.parse(JSON.stringify(element?.form_form_column_data));
        console.log({ updatedData });
        // 遍歷並更新 response_form_value_data
        if (!Array.isArray(updatedData) || updatedData.length === 0) {
            return form_form_column_data_sample;
        }
        updatedData.forEach(formColumn => {
            if (!formColumn?.form_column_source_data) {
                formColumn.form_column_source_data = [{}]
            }
            const sourceData = formColumn?.form_column_source_data || [];
            sourceData.forEach(source => {
                if (!source?.document_source_data) {
                    source.document_source_data = [{}];
                }
                const docSourceData = source?.document_source_data || [];
                docSourceData.forEach(docSource => {
                    if (!docSource?.sample_data) {
                        docSource.sample_data = [{}];
                    }
                    const sampleData = docSource?.sample_data || []
                    sampleData.forEach(sample => {
                        if (!sample?.document_response_data) {
                            sample.document_response_data = [{}];
                        }
                        const docResponseData = sample?.document_response_data || [];
                        docResponseData.forEach(docResponse => {
                            // 這裡是關鍵：只替換 response_form_value_data
                            docResponse.response_form_value_data = changedFormColumnData;
                        });
                    });
                });
            });
        });

        return updatedData;
    }
    const documentController = useCRUDController({
        apiRoute: "/utility/document",
        onFinish: ({ axiosMode, status, values }) => { },
        onBefore: () => { },
    });
    const responseController = useCRUDController({
        apiRoute: "/utility/response",
        onFinish: ({ axiosMode, status, values }) => { },
        onBefore: () => { },
    });
    // useEffect(() => {
    //     let fiveWDataTemp2 = transformFormColumnDataToFiveWData(form_form_column_data)
    // }, [base_form_form_column_data])
    useEffect(() => {

        // let newData = getElement5wFormColumns(element);
        // element 已經有填寫的資料
        let element_form_form_column_data = element?.form_form_column_data || []
        let form_form_column_data_first = element_form_form_column_data?.find((e) => true)
        let form_column_source_data = form_form_column_data_first?.form_column_source_data || []
        let document_source_data = form_column_source_data?.[0]?.document_source_data || []
        let document_source_data_first = document_source_data?.find((e) => true)
        let sample_data = document_source_data_first?.sample_data || []
        let sample_data_first = sample_data?.find((e) => true)

        let document_response_data = sample_data_first?.document_response_data || []
        let document_response_data_first = document_response_data?.find((e) => true)
        let response_form_value_data = document_response_data_first?.response_form_value_data || []

        if (response_form_value_data.length > 0) {
            setFormFormColumnData(response_form_value_data);
        }
        else {
            let document_classify_structure_type_data = baseDisplayDocumentValue?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((e) => true)
            let display_document_form_data = document_classify_structure_type_data_first?.document_form_data || []
            let display_document_form_data_first = display_document_form_data?.find((e) => true)
            let displayFormFormColumnData = display_document_form_data_first?.form_form_column_data || []
            console.log({
                displayFormFormColumnData
            })
            setFormFormColumnData(displayFormFormColumnData);
        }
    }, [element?.id])
    useEffect(() => {
        if (!!baseDisplayDocumentValue) {
            let sample_data = getSampleData(element);
            let sample_data_first = sample_data?.find((_) => true)
            let sample_documnet_id = sample_data_first?.document_id || null
            if (!!sample_documnet_id) {
                documentController.getData({
                    base_on_classify_structure: true,
                    document_id: sample_documnet_id
                })
                    .then((res) => {
                        let data = res?.data || [];
                        let documentData = data?.find((ele) => true)
                        let document_form_data = documentData?.document_form_data || []
                        let document_form_data_first = document_form_data?.find((e) => true)
                        let form_form_column_data = document_form_data_first?.form_form_column_data || []
                        setFormFormColumnData(form_form_column_data);
                        setDisplayDocumentValue(documentData);
                    })
            }
            else {
                // // element 已經有填寫的資料
                // let element_form_form_column_data = element?.form_form_column_data || []
                // let form_form_column_data_first = element_form_form_column_data?.find((e) => true)
                // let form_column_source_data = form_form_column_data_first?.form_column_source_data || []
                // let document_source_data = form_column_source_data?.[0]?.document_source_data || []
                // let document_source_data_first = document_source_data?.find((e) => true)
                // let document_form_data = document_source_data_first?.document_form_data || []
                // let document_form_data_first = document_form_data?.find((e) => true)
                // let form_form_column_data = document_form_data_first?.form_form_column_data || []

                //displayDocumentValue
                let document_classify_structure_type_data = baseDisplayDocumentValue?.document_classify_structure_type_data || []
                let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((e) => true)
                let display_document_form_data = document_classify_structure_type_data_first?.document_form_data || []
                let display_document_form_data_first = display_document_form_data?.find((e) => true)
                let displayFormFormColumnData = display_document_form_data_first?.form_form_column_data || []
                if (form_form_column_data.length > 0) {
                    setDisplayDocumentValue(baseDisplayDocumentValue)
                    setFormFormColumnData(form_form_column_data);
                }
                else {
                    setDisplayDocumentValue(baseDisplayDocumentValue)
                    setFormFormColumnData(displayFormFormColumnData);
                }

            }
        }
    }, [baseDisplayDocumentValue])

    // useEffect(() => {
    //     console.log({
    //         form_form_column_data,
    //         temp: transformFormColumnDataToFiveWData(form_form_column_data)
    //     });
    // }, [form_form_column_data])
    return (
        <Row gutter={[4, 4]}>
            <Col span={24}>
                <div >
                    <Label className="text-sm font-medium">
                        步驟標題
                    </Label>
                    <Input
                        type="text"
                        className="mt-1"
                        value={element?.title || ''}
                        onChange={(e) => {
                            onChangecanvasElement(e.target.value, 'title');
                        }}
                    />
                </div>
            </Col>
            <Col span={24}>
                <div >
                    <Label className="text-sm font-medium">
                        步驟描述
                    </Label>
                    <Input
                        type="text"
                        className="mt-1"
                        value={element?.description || ''}
                        onChange={(e) => {
                            onChangecanvasElement(e.target.value, 'description');
                        }}
                    />
                </div>
            </Col>
            <Col span={24}>
                <div >
                    <Label className="text-sm font-medium">
                        步驟目標
                    </Label>
                    <Input
                        type="text"
                        className="mt-1"
                        value={element?.content || ''}
                        onChange={(e) => {
                            onChangecanvasElement(e.target.value, 'content');
                        }}
                    />
                </div>
            </Col>
            <Col span={24}>
                <div >
                    <Label className="text-sm font-medium">
                        步驟類型
                    </Label>
                    <Select value={element?.type || ''} onValueChange={(value) => {
                        onChangecanvasElement(value, 'type');
                    }}>
                        <SelectTrigger className="mt-1">
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem key={"start_node"} value={"start_node"}>
                                開始
                            </SelectItem>
                            <SelectItem key={"process_node"} value={"process_node"}>
                                處理步驟
                            </SelectItem>
                            <SelectItem key={"decision_node"} value={"decision_node"}>
                                判斷節點
                            </SelectItem>
                            <SelectItem key={"end_node"} value={"end_node"}>
                                結束
                            </SelectItem>
                        </SelectContent>
                    </Select>
                </div>
            </Col>
            <Col span={24}>
                <div>
                    <Label className="text-sm font-medium">
                        是否經過審核
                    </Label>

                    <RadioGroup
                        className="mt-2 flex gap-6"
                        value={String(element?.need_review ?? 0)}
                        onValueChange={(value) => {
                            onChangecanvasElement(Number(value), 'need_review');
                        }}
                    >
                        <div className="flex items-center space-x-2">
                            <RadioGroupItem value="1" id="need_review_yes" />
                            <Label htmlFor="need_review_yes">是</Label>
                        </div>

                        <div className="flex items-center space-x-2">
                            <RadioGroupItem value="0" id="need_review_no" />
                            <Label htmlFor="need_review_no">否</Label>
                        </div>
                    </RadioGroup>
                </div>
            </Col>
            {element?.type === "decision_node" && (
                <Col span={24}>
                    <div >
                        <Label className="text-sm font-medium">
                            判斷流向設定
                        </Label>
                        <div className="mt-2">
                            {/* 分支編輯區 */}
                            <DecisionBranchEditor
                                element={element}
                                onChangecanvasElement={onChangecanvasElement}
                            />
                        </div>
                    </div>
                </Col>
            )}
            <Col span={24}>
                <TempDataProvider>
                    <Base5wCard
                        key={element?.id}
                        cardsPerRow={1}

                        propsFiveWData={transformFormColumnDataToFiveWData(form_form_column_data)}
                        onChange={(value) => {
                            let changedFormColumnData = transformFiveWDataToFormColumnData(value?.five_w_data);

                            // 複製一份 element
                            let newElement = { ...element };
                            // let temp = updateInnerFormColumnData(newElement, changedFormColumnData)

                            let form_form_column_data_new = updatedElementFormFormColumnData(newElement, changedFormColumnData);
                            console.log({
                                // element, newElement, changedFormColumnData,
                                form_form_column_data_new,
                                changedFormColumnData
                            })
                            // let form_form_column_data_outside = temp?.form_form_column_data || []
                            // let form_form_column_data_outside_first = form_form_column_data_outside?.find((_) => true)

                            // console.log({ value, changedFormColumnData, temp, form_form_column_data_outside_first });

                            // 回傳完整 newElement
                            onChangecanvasElement(form_form_column_data_new?.[0], "form_form_column_data");
                        }}
                        fiveWResponseData={fiveWResponseData}
                        allDocumentData={allDocumentData}
                    />
                </TempDataProvider>
            </Col>
        </Row >
    )
}
export default BaseCanvasEdit3_1;

const DecisionBranchEditor = ({ element, onChangecanvasElement }) => {
    const [edges, setEdges] = useState([]);

    // derive possible step targets from element.form_form_column_data
    const stepOptions = (element?.form_form_column_data || []).map((ffc, idx) => {
        // try several candidate labels
        const title = ffc?.code || ffc?.index || `步驟 ${idx + 1}`;
        const id = ffc?.form_column_id ?? ffc?.form_form_column_id ?? idx;
        return { label: title, value: id };
    });

    // helper to get nested form_column_edge_data path (first item)
    const readEdgesFromElement = () => {
        try {
            const ffc = element?.form_form_column_data || [];
            const first = ffc?.[0] || {};
            return first?.form_column_edge_data || [];
        } catch (e) {
            return [];
        }
    };

    useEffect(() => {
        setEdges(readEdgesFromElement());
    }, [element?.id]);

    // push changes back to element
    const persistEdges = (newEdges) => {
        // create deep clone of form_form_column_data
        const ffc = JSON.parse(JSON.stringify(element?.form_form_column_data || []));
        if (ffc.length === 0) {
            // create a default wrapper if missing
            ffc.push({ form_column_edge_data: newEdges });
        } else {
            ffc[0].form_column_edge_data = newEdges;
        }
        // notify parent (keep shape as array)
        onChangecanvasElement(ffc, 'form_form_column_data');
    };

    const addBranch = () => {
        const newEdge = {
            edge_id: Date.now() * -1,
            description: '',
            bidirectional: 0,
            form_column_id: null,
            to_form_column_id: null,
            form_column_edge_id: Date.now(),
            from_form_column_id: null,
        };
        const newEdges = [...edges, newEdge];
        setEdges(newEdges);
        persistEdges(newEdges);
    };

    const updateBranch = (index, patch) => {
        const newEdges = edges.map((e, i) => (i === index ? { ...e, ...patch } : e));
        setEdges(newEdges);
        persistEdges(newEdges);
    };

    const deleteBranch = (index) => {
        const newEdges = edges.filter((_, i) => i !== index);
        setEdges(newEdges);
        persistEdges(newEdges);
    };

    return (
        <div className="space-y-3 p-3 rounded-md bg-gray-50 border border-gray-100">
            <div className="flex items-center justify-between">
                <div className="text-sm text-gray-700">分支路徑</div>
                <Button size="sm" onClick={addBranch}>+ 新增分支</Button>
            </div>

            <div className="space-y-3">
                {edges.length === 0 && (
                    <div className="text-sm text-muted-foreground">目前沒有分支</div>
                )}
                {edges.map((edge, idx) => (
                    <div key={edge.edge_id ?? idx} className={`p-3 rounded border ${edge?.bidirectional ? 'border-green-200 bg-green-50' : 'border-gray-200 bg-white'}`}>
                        <div className="flex items-center mb-2">
                            <div className="font-medium flex-1">{`分支 ${idx + 1}`}</div>
                            <Button variant="ghost" size="sm" onClick={() => deleteBranch(idx)} className="text-red-500">刪除</Button>
                        </div>
                        <div className="space-y-2">
                            <div>
                                <Label className="text-xs">條件名稱</Label>
                                <Input
                                    className="mt-1"
                                    value={edge.description || ''}
                                    onChange={(e) => updateBranch(idx, { description: e.target.value })}
                                    placeholder="條件名稱（如：通過、符合）"
                                />
                            </div>
                            <div>
                                <Label className="text-xs">前往步驟</Label>
                                <Select value={edge.to_form_column_id ?? ''} onValueChange={(val) => updateBranch(idx, { to_form_column_id: val })}>
                                    <SelectTrigger className="mt-1">
                                        <SelectValue placeholder="選擇要前往的步驟" />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {stepOptions.map((opt) => (
                                            <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </div>
                            <div className="flex items-center gap-2">
                                <label className="flex items-center gap-2 text-sm">
                                    <input type="checkbox" checked={!!edge.bidirectional} onChange={(e) => updateBranch(idx, { bidirectional: e.target.checked ? 1 : 0 })} />
                                    雙向
                                </label>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
// end DecisionBranchEditor
